<template>
  <v-app class="ta-app" style="background: #0a0a0a !important;">
    <v-app-bar app dark color="#111111" elevation="0" height="60" class="ta-admin-appbar" style="border-bottom: 1px solid #1f1f1f;">
      <v-btn icon class="ta-back-btn mr-1" @click="voltarDashboard">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <div class="d-flex align-center ml-1">
        <div class="ta-logo-icon mr-2">
          <span class="ta-logo-e">E</span>
        </div>
        <div>
          <div class="ta-logo-text">ElevMent</div>
          <div class="ta-logo-sub">Admin</div>
        </div>
      </div>

      <v-spacer />

      <div class="d-flex align-center mr-2">
        <v-btn text class="ta-header-btn" @click="logout">
          <v-icon left small>mdi-logout</v-icon>
          Sair
        </v-btn>
      </div>
    </v-app-bar>

    <v-main style="background: #0a0a0a !important;">
      <v-container fluid class="ta-container pa-6 px-10" style="max-width: 1280px; margin: auto; background: #0a0a0a;">

        <div class="mb-5">
          <h1 style="font-size: 26px; font-weight: 700; color: #FFFFFF; letter-spacing: -0.02em; margin: 0;">Configurações do Admin</h1>
          <div style="font-size: 13px; color: rgba(255,255,255,0.45); margin-top: 4px;">{{ userEmail }}</div>
        </div>

        <div class="ta-card-main">
          <v-tabs v-model="activeTab" background-color="transparent" dark color="#22d3ee" slider-color="#22d3ee" slider-size="3">
            <v-tab class="text-capitalize">
              <v-icon small class="mr-2">mdi-domain</v-icon>
              Tenant
            </v-tab>
            <v-tab class="text-capitalize">
              <v-icon small class="mr-2">mdi-cash-multiple</v-icon>
              Financeiro
            </v-tab>
            <v-tab class="text-capitalize">
              <v-icon small class="mr-2">mdi-connection</v-icon>
              Conectores
            </v-tab>
            <v-tab class="text-capitalize">
              <v-icon small class="mr-2">mdi-account-group</v-icon>
              Usuários
            </v-tab>
            <v-tab class="text-capitalize">
              <v-icon small class="mr-2">mdi-shield-lock</v-icon>
              Segurança
            </v-tab>
          </v-tabs>
        
          <v-tabs-items v-model="activeTab" style="background: transparent !important;">
            <v-tab-item>
              <v-container fluid class="pa-6">
                <v-row>
                  <v-col cols="12">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6">
                        <v-icon class="mr-3" style="color: #22d3ee">mdi-domain</v-icon>
                        <div>
                          <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Dados da Empresa</span>
                          <div class="text-caption" style="color: rgba(255,255,255,0.6)">Informações cadastrais do tenant</div>
                        </div>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="tenantData.razaoSocial"
                              label="Razão Social"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="tenantData.nomeFantasia"
                              label="Nome Fantasia"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="tenantData.cnpj"
                              label="CNPJ"
                              placeholder="00.000.000/0000-00"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              v-model="tenantData.setor"
                              :items="setores"
                              label="Setor"
                              filled
                              hide-details="auto"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="tenantData.telefone"
                              label="Telefone"
                              placeholder="(00) 00000-0000"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="tenantData.website"
                              label="Website"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              v-model="tenantData.porteEmpresa"
                              :items="portesEmpresa"
                              label="Porte da Empresa"
                              filled
                              hide-details="auto"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="tenantData.endereco"
                              label="Endereço"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6">
                        <v-icon class="mr-3" style="color: #22d3ee">mdi-account-tie</v-icon>
                        <div>
                          <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Responsável pelo Contrato</span>
                          <div class="text-caption" style="color: rgba(255,255,255,0.6)">Contato principal para questões contratuais e administrativas</div>
                        </div>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="responsavelData.nomeCompleto"
                              label="Nome Completo"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="responsavelData.cargo"
                              label="Cargo"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="responsavelData.email"
                              label="E-mail"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="responsavelData.telefone"
                              label="Telefone"
                              placeholder="(00) 00000-0000"
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6">
                        <v-icon class="mr-3" style="color: #22d3ee">mdi-file-document</v-icon>
                        <div>
                          <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Informações do Contrato</span>
                          <div class="text-caption" style="color: rgba(255,255,255,0.6)">Detalhes da vigência e condições contratuais</div>
                        </div>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field
                              :value="contratoData.dataInicio"
                              label="Início do Contrato"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          
                          <v-col cols="12" md="4">
                            <v-text-field
                              :value="contratoData.dataTermino"
                              label="Término do Contrato"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              filled
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          
                          <v-col cols="12" md="4">
                            <div class="text-caption grey--text mb-1">Dias Restantes</div>
                            <v-chip
                              :color="diasRestantesColor"
                              dark
                              class="px-4 py-5"
                              style="width: 100%; justify-content: center;"
                            >
                              <span class="text-h6 font-weight-bold">{{ diasRestantes }} dias</span>
                              <v-icon right>{{ diasRestantesIcon }}</v-icon>
                            </v-chip>
                          </v-col>
                          
                          <v-col cols="12" md="6">
                            <v-select
                              v-model="contratoData.plano"
                              :items="planos"
                              label="Plano Contratado"
                              filled
                              hide-details="auto"
                            ></v-select>
                          </v-col>
                          
                          <v-col cols="12" md="6">
                            <v-select
                              v-model="contratoData.formaPagamento"
                              :items="formasPagamento"
                              label="Forma de Pagamento"
                              filled
                              hide-details="auto"
                            ></v-select>
                          </v-col>
                          
                          <v-col cols="12">
                            <v-textarea
                              v-model="contratoData.observacoes"
                              label="Observações do Contrato"
                              filled
                              rows="3"
                              hide-details="auto"
                              placeholder="Ex: Contrato renovado automaticamente. Suporte prioritário incluso."
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6">
                        <v-icon class="mr-3" style="color: #22d3ee">mdi-lock-outline</v-icon>
                        <div>
                          <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Configurações de Acesso</span>
                          <div class="text-caption" style="color: rgba(255,255,255,0.6)">Políticas de acesso e autenticação</div>
                        </div>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col cols="12">
                            <v-switch
                              v-model="acessoData.permitirCadastroNovosUsuarios"
                              color="success"
                              hide-details
                            >
                              <template v-slot:label>
                                <div>
                                  <div class="font-weight-medium">Permitir cadastro de novos usuários</div>
                                  <div class="text-caption grey--text">Usuários podem se cadastrar com e-mail da organização</div>
                                </div>
                              </template>
                            </v-switch>
                          </v-col>
                          <v-col cols="12">
                            <v-switch
                              v-model="acessoData.autenticacaoDoisFatores"
                              color="success"
                              hide-details
                            >
                              <template v-slot:label>
                                <div>
                                  <div class="font-weight-medium">Autenticação de dois fatores (MFA)</div>
                                  <div class="text-caption grey--text">Exigir MFA para todos os usuários</div>
                                </div>
                              </template>
                            </v-switch>
                          </v-col>
                          <v-col cols="12">
                            <v-switch
                              v-model="acessoData.singleSignOn"
                              color="success"
                              hide-details
                            >
                              <template v-slot:label>
                                <div>
                                  <div class="font-weight-medium">Single Sign-On (SSO)</div>
                                  <div class="text-caption grey--text">Permitir login via provedor corporativo</div>
                                </div>
                              </template>
                            </v-switch>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" class="text-right">
                    <v-btn color="grey" text large class="mr-2" @click="voltar">
                      <v-icon left>mdi-arrow-left</v-icon>
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="success"
                      large
                      elevation="0"
                      :loading="salvando"
                      @click="salvarConfiguracoes"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      Salvar Alterações
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item>
              <v-container fluid class="pa-6">
                <v-row class="mb-2">
                  <v-col cols="12" sm="6" lg="3">
                    <v-card flat dark class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center mb-3">
                        <v-avatar color="rgba(34,211,238,0.15)" size="40" class="mr-3">
                          <v-icon color="#22d3ee">mdi-account-group</v-icon>
                        </v-avatar>
                        <span class="text-caption" style="color:#888888">Usuários Ativos</span>
                      </div>
                      <div class="text-h4 font-weight-bold" style="color:#f5f5f5">{{ financeiroData.usuariosAtivos }}</div>
                      <div class="text-caption mt-1" style="color:#888888">de {{ financeiroData.usuariosTotais }} usuários totais</div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="6" lg="3">
                    <v-card flat dark class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center mb-3">
                        <v-avatar color="rgba(34,211,238,0.15)" size="40" class="mr-3">
                          <v-icon color="#22d3ee">mdi-currency-usd</v-icon>
                        </v-avatar>
                        <span class="text-caption" style="color:#888888">Custo por Usuário</span>
                      </div>
                      <div class="text-h4 font-weight-bold" style="color:#f5f5f5">{{ formatCurrency(financeiroData.custoUsuario) }}</div>
                      <div class="text-caption mt-1" style="color:#888888">por mês</div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="6" lg="3">
                    <v-card flat dark class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center mb-3">
                        <v-avatar color="rgba(139,92,246,0.15)" size="40" class="mr-3">
                          <v-icon color="#8b5cf6">mdi-receipt-text</v-icon>
                        </v-avatar>
                        <span class="text-caption" style="color:#888888">Fatura Atual</span>
                      </div>
                      <div class="text-h4 font-weight-bold" style="color:#f5f5f5">{{ formatCurrency(faturaAtualTotal) }}</div>
                      <div class="text-caption mt-1" style="color:#4ade80">
                        <v-icon x-small color="#4ade80">mdi-tag</v-icon>
                        {{ financeiroData.fatura.descontoPercent }}% desconto aplicado
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="6" lg="3">
                    <v-card flat dark class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center mb-3">
                        <v-avatar color="rgba(74,222,128,0.15)" size="40" class="mr-3">
                          <v-icon color="#4ade80">mdi-trending-up</v-icon>
                        </v-avatar>
                        <span class="text-caption" style="color:#888888">Crescimento</span>
                      </div>
                      <div class="text-h4 font-weight-bold" style="color:#4ade80">+{{ financeiroData.crescimentoPercent }}%</div>
                      <div class="text-caption mt-1" style="color:#888888">vs. mês anterior</div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6">
                        <v-icon class="mr-3" style="color: #22d3ee">mdi-file-document-outline</v-icon>
                        <div>
                          <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Fatura Atual — {{ financeiroData.fatura.mesReferencia }}</span>
                          <div class="text-caption" style="color: rgba(255,255,255,0.6)">
                            Vencimento: {{ financeiroData.fatura.vencimento }}
                          </div>
                        </div>
                        <v-spacer></v-spacer>
                        <v-chip
                          :color="statusFaturaColor"
                          small
                          class="font-weight-medium"
                          :style="{ color: statusFaturaTextColor }"
                        >
                          {{ financeiroData.fatura.status }}
                        </v-chip>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr style="background-color: #0d0d0d !important;">
                                <th class="text-left pa-4">Descrição</th>
                                <th class="text-center pa-4">Qtd</th>
                                <th class="text-right pa-4">Valor Unitário</th>
                                <th class="text-right pa-4">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in financeiroData.fatura.itens" :key="index">
                                <td class="pa-4">{{ item.descricao }}</td>
                                <td class="text-center pa-4">{{ item.quantidade }}</td>
                                <td class="text-right pa-4">{{ formatCurrency(item.valorUnitario) }}</td>
                                <td class="text-right pa-4">{{ formatCurrency(item.quantidade * item.valorUnitario) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>

                        <v-divider></v-divider>

                        <div class="pa-4">
                          <v-row no-gutters class="mb-2">
                            <v-col class="text-right grey--text text--darken-1">
                              Subtotal
                            </v-col>
                            <v-col cols="3" class="text-right font-weight-medium">
                              {{ formatCurrency(faturaSubtotal) }}
                            </v-col>
                          </v-row>
                          <v-row no-gutters class="mb-2">
                            <v-col class="text-right green--text text--darken-1">
                              Desconto ({{ financeiroData.fatura.descontoPercent }}%)
                            </v-col>
                            <v-col cols="3" class="text-right green--text text--darken-1 font-weight-medium">
                              -{{ formatCurrency(faturaDesconto) }}
                            </v-col>
                          </v-row>
                          <v-divider class="mb-3"></v-divider>
                          <v-row no-gutters>
                            <v-col class="text-right text-h6 font-weight-bold">
                              Total
                            </v-col>
                            <v-col cols="3" class="text-right text-h6 font-weight-bold">
                              {{ formatCurrency(faturaAtualTotal) }}
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions class="pa-4">
                        <v-spacer></v-spacer>
                        <v-btn outlined color="grey darken-1" @click="baixarFaturaPDF" :loading="baixandoPDF">
                          <v-icon left small>mdi-download</v-icon>
                          Baixar PDF
                        </v-btn>
                        <v-btn color="success" elevation="0" @click="pagarFatura" :loading="pagando" class="ml-3">
                          <v-icon left small>mdi-credit-card-outline</v-icon>
                          Pagar Agora
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6 d-flex align-center">
                        <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Evolução de Usuários</span>
                        <v-spacer></v-spacer>
                        <v-select
                          v-model="evolucaoPeriodo"
                          :items="['3 meses', '6 meses', '12 meses']"
                          dense
                          filled
                          hide-details
                          style="max-width: 130px;"
                        ></v-select>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-6">
                        <div style="position: relative; height: 250px;">
                          <canvas ref="evolucaoChart"></canvas>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6">
                        <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Custo por Departamento</span>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-6">
                        <div v-for="dept in custoDepartamentos" :key="dept.nome" class="mb-4">
                          <div class="d-flex align-center justify-space-between mb-1">
                            <span class="text-body-2 grey--text text--darken-2">{{ dept.nome }}</span>
                            <span class="text-body-2 font-weight-medium">{{ formatCurrency(dept.custo) }}</span>
                          </div>
                          <v-progress-linear
                            :value="(dept.custo / custoMaxDepartamento) * 100"
                            color="success"
                            background-color="grey lighten-3"
                            height="20"
                            rounded
                          ></v-progress-linear>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6">
                        <v-icon class="mr-3" style="color: #22d3ee">mdi-calendar-text</v-icon>
                        <div>
                          <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Histórico de Faturas</span>
                          <div class="text-caption" style="color: rgba(255,255,255,0.6)">Últimas faturas emitidas</div>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn outlined color="grey darken-1" @click="exportarRelatorio">
                          <v-icon left small>mdi-download</v-icon>
                          Exportar Relatório
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr style="background-color: #0d0d0d !important;">
                                <th class="text-left pa-4">Fatura</th>
                                <th class="text-left pa-4">Período</th>
                                <th class="text-center pa-4">Usuários</th>
                                <th class="text-right pa-4">Valor</th>
                                <th class="text-center pa-4">Status</th>
                                <th class="text-center pa-4">Pagamento</th>
                                <th class="text-center pa-4">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="fatura in historicoFaturas" :key="fatura.id">
                                <td class="pa-4 font-weight-medium">{{ fatura.id }}</td>
                                <td class="pa-4">{{ fatura.periodo }}</td>
                                <td class="text-center pa-4">{{ fatura.usuarios }}</td>
                                <td class="text-right pa-4 font-weight-medium">{{ formatCurrency(fatura.valor) }}</td>
                                <td class="text-center pa-4">
                                  <v-chip
                                    :color="fatura.status === 'Pago' ? '#16351f' : '#3a2708'"
                                    small
                                    class="font-weight-medium"
                                  >
                                    <v-icon x-small left :color="fatura.status === 'Pago' ? '#4ade80' : '#fbbf24'">{{ fatura.status === 'Pago' ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
                                    <span :style="{ color: fatura.status === 'Pago' ? '#4ade80' : '#fbbf24' }">{{ fatura.status }}</span>
                                  </v-chip>
                                </td>
                                <td class="text-center pa-4" style="color:rgba(255,255,255,0.45); font-size:12px;">{{ fatura.dataPagamento }}</td>
                                <td class="text-center pa-4">
                                  <v-btn icon small @click="baixarFaturaHistorico(fatura.id)" style="color:rgba(255,255,255,0.45);">
                                    <v-icon small>mdi-download</v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="py-4 px-6">
                        <v-icon class="mr-3" style="color: #22d3ee">mdi-account-multiple</v-icon>
                        <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Distribuição de Usuários</span>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-6">
                        <v-row>
                          <v-col v-for="grupo in distribuicaoUsuarios" :key="grupo.label" cols="12" md="4">
                            <v-card outlined class="rounded-lg pa-4">
                              <div class="d-flex align-center justify-space-between mb-3">
                                <span class="text-body-1 grey--text text--darken-2">{{ grupo.label }}</span>
                                <span class="text-h5 font-weight-bold">{{ grupo.quantidade }}</span>
                              </div>
                              <v-progress-linear
                                :value="(grupo.quantidade / totalUsuariosDistribuicao) * 100"
                                :color="grupo.cor"
                                height="8"
                                rounded
                              ></v-progress-linear>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item>
              <v-container fluid class="pa-6">
                <div class="mb-6">
                  <div class="text-h5 font-weight-bold grey--text text--darken-3">Conectores</div>
                  <div class="text-body-2 grey--text text--darken-1">Configure integrações com ferramentas de desenvolvimento</div>
                </div>

                <v-row>
                  <v-col v-for="conector in conectores" :key="conector.id" cols="12" sm="6" md="4">
                    <v-card 
                      outlined 
                      class="rounded-lg d-flex flex-column" 
                      style="height: 320px; padding: 20px;"
                    >
                      <div class="d-flex align-center mb-4" style="min-height: 60px;">
                        <v-avatar size="40" tile class="mr-3" style="flex-shrink: 0;">
                          <v-icon :color="conector.iconColor" size="24">{{ conector.icon }}</v-icon>
                        </v-avatar>
                        <span class="text-h6 font-weight-bold grey--text text--darken-3" style="line-height: 1.2;">{{ conector.nome }}</span>
                        <v-spacer></v-spacer>
                        <v-chip
                          :color="conector.conectado ? '#16351f' : '#1f1f1f'"
                          :text-color="conector.conectado ? '#4ade80' : '#888888'"
                          x-small
                          class="font-weight-medium"
                          style="flex-shrink: 0;"
                        >
                          {{ conector.conectado ? 'Conectado' : 'Desconectado' }}
                        </v-chip>
                      </div>

                      <div 
                        class="text-body-2 grey--text text--darken-1 mb-3" 
                        style="flex-grow: 1; min-height: 80px; line-height: 1.5; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 4; line-clamp: 4; -webkit-box-orient: vertical;"
                      >
                        {{ conector.descricao }}
                      </div>

                      <div 
                        v-if="conector.conectado && conector.accountLogin" 
                        class="mb-3" 
                        style="height: 50px; display: flex; flex-direction: column; justify-content: center;"
                      >
                        <v-divider class="mb-2"></v-divider>
                        <div class="d-flex align-center">
                          <v-icon small color="grey darken-1" class="mr-2">mdi-account-circle</v-icon>
                          <span class="text-caption grey--text text--darken-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ conector.accountLogin }}</span>
                        </div>
                      </div>

                      <div v-else style="height: 50px;"></div>

                      <div style="height: 48px;">
                        <v-btn
                          v-if="!conector.conectado"
                          outlined
                          block
                          large
                          color="grey darken-1"
                          :loading="conector.loading"
                          @click="conectarIntegracao(conector)"
                          style="height: 48px;"
                        >
                          <v-icon left small>mdi-connection</v-icon>
                          Conectar
                        </v-btn>
                        <v-btn
                          v-else
                          outlined
                          block
                          large
                          color="red darken-1"
                          :loading="conector.loading"
                          @click="desconectarIntegracao(conector)"
                          style="height: 48px;"
                        >
                          <v-icon left small>mdi-link-off</v-icon>
                          Desconectar
                        </v-btn>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item>
              <v-container fluid class="pa-6">
                <v-row class="mb-4">
                  <v-col cols="12" sm="6" md="3">
                    <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center">
                        <v-avatar color="rgba(34,211,238,0.15)" size="40" class="mr-3">
                          <v-icon color="#22d3ee">mdi-account-group</v-icon>
                        </v-avatar>
                        <div>
                          <div class="text-h4 font-weight-bold white--text">{{ usuariosPlataforma.length }}</div>
                          <div class="text-caption" style="color:rgba(255,255,255,0.5)">Total de Usuários</div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center">
                        <v-avatar color="rgba(239,68,68,0.15)" size="40" class="mr-3">
                          <v-icon color="#F87171">mdi-shield-account</v-icon>
                        </v-avatar>
                        <div>
                          <div class="text-h4 font-weight-bold white--text">{{ totalAdmins }}</div>
                          <div class="text-caption" style="color:rgba(255,255,255,0.5)">Administradores</div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center">
                        <v-avatar color="rgba(96,165,250,0.15)" size="40" class="mr-3">
                          <v-icon color="#60a5fa">mdi-account-tie</v-icon>
                        </v-avatar>
                        <div>
                          <div class="text-h4 font-weight-bold white--text">{{ totalGestores }}</div>
                          <div class="text-caption" style="color:rgba(255,255,255,0.5)">Gestores</div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center">
                        <v-avatar color="rgba(161,161,170,0.15)" size="40" class="mr-3">
                          <v-icon color="#a1a1aa">mdi-account</v-icon>
                        </v-avatar>
                        <div>
                          <div class="text-h4 font-weight-bold white--text">{{ totalColaboradores }}</div>
                          <div class="text-caption" style="color:rgba(255,255,255,0.5)">Colaboradores</div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                      <div class="d-flex align-center">
                        <v-avatar color="rgba(74,222,128,0.15)" size="40" class="mr-3">
                          <v-icon color="#4ade80">mdi-check-circle</v-icon>
                        </v-avatar>
                        <div>
                          <div class="text-h4 font-weight-bold white--text">{{ totalAtivos }}</div>
                          <div class="text-caption" style="color:rgba(255,255,255,0.5)">Ativos</div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-card flat dark class="rounded-lg" color="#111111">
                  <v-card-title class="px-6 pt-5 pb-2">
                    <div>
                      <div class="text-h5 font-weight-bold" style="color: #FFFFFF">Usuários da Plataforma</div>
                      <div class="text-body-2" style="color: rgba(255,255,255,0.6)">Gerencie administradores, gestores e colaboradores</div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="#22d3ee" dark elevation="0" @click="dialogConvidarUsuario = true">
                      <v-icon left>mdi-account-plus</v-icon>
                      Convidar Usuário
                    </v-btn>
                  </v-card-title>

                  <v-card-text class="px-6 pb-2">
                    <v-row align="center">
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="buscaUsuario"
                          placeholder="Buscar por nome ou e-mail..."
                          prepend-inner-icon="mdi-magnify"
                          filled
                          dense
                          hide-details
                          clearable
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" md="3">
                        <v-select
                          v-model="filtroPerfil"
                          :items="opcoesPerfil"
                          label="Todos os perfis"
                          filled
                          dense
                          hide-details
                          clearable
                          prepend-inner-icon="mdi-filter-variant"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" md="3">
                        <v-select
                          v-model="filtroStatus"
                          :items="opcoesStatus"
                          label="Todos os status"
                          filled
                          dense
                          hide-details
                          clearable
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr style="background-color: #0d0d0d !important;">
                          <th class="text-left pa-4">Usuário</th>
                          <th class="text-left pa-4">Perfil</th>
                          <th class="text-left pa-4">Departamento</th>
                          <th class="text-center pa-4">Status</th>
                          <th class="text-center pa-4">MFA</th>
                          <th class="text-left pa-4">Último Acesso</th>
                          <th class="text-center pa-4">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="usuario in usuariosFiltrados" :key="usuario.id">
                          <td class="pa-4">
                            <div class="d-flex align-center">
                              <v-avatar :color="getAvatarColorByName(usuario.nome)" size="36" class="mr-3">
                                <span class="text-body-2 font-weight-bold white--text">{{ usuario.iniciais }}</span>
                              </v-avatar>
                              <div>
                                <div class="font-weight-medium white--text">{{ usuario.nome }}</div>
                                <div class="text-caption" style="color:rgba(255,255,255,0.45)">{{ usuario.email }}</div>
                              </div>
                            </div>
                          </td>
                          <td class="pa-4">
                            <v-chip
                              :color="perfilChipColor(usuario.perfil).bg"
                              text-color="white"
                              small
                              class="font-weight-medium"
                            >
                              <v-icon x-small left>{{ perfilChipColor(usuario.perfil).icon }}</v-icon>
                              {{ usuario.perfil }}
                            </v-chip>
                          </td>
                          <td class="pa-4" style="color:rgba(255,255,255,0.8)">{{ usuario.departamento }}</td>
                          <td class="text-center pa-4">
                            <v-chip
                              :color="usuario.status === 'Ativo' ? '#16351f' : '#1f1f1f'"
                              small
                            >
                              <v-icon x-small left :color="usuario.status === 'Ativo' ? '#22c55e' : '#555555'">{{ usuario.status === 'Ativo' ? 'mdi-circle' : 'mdi-minus-circle' }}</v-icon>
                              <span :style="{ color: usuario.status === 'Ativo' ? '#86efac' : '#777777' }">{{ usuario.status }}</span>
                            </v-chip>
                          </td>
                          <td class="text-center pa-4">
                            <v-chip
                              :color="usuario.mfa ? '#16351f' : '#1f1f1f'"
                              small
                            >
                              <v-icon x-small left :color="usuario.mfa ? '#22c55e' : '#555555'">{{ usuario.mfa ? 'mdi-check-circle' : 'mdi-minus-circle' }}</v-icon>
                              <span :style="{ color: usuario.mfa ? '#86efac' : '#777777' }">{{ usuario.mfa ? 'Ativo' : 'Inativo' }}</span>
                            </v-chip>
                          </td>
                          <td class="pa-4" style="color:rgba(255,255,255,0.5); font-size:12px;">{{ usuario.ultimoAcesso }}</td>
                          <td class="text-center pa-4">
                            <div class="d-flex align-center justify-center" style="gap:4px;">
                              <v-btn icon x-small @click="editarUsuario(usuario)" style="color:rgba(255,255,255,0.5);">
                                <v-icon small>mdi-pencil-outline</v-icon>
                              </v-btn>
                              <v-menu offset-y left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon x-small v-bind="attrs" v-on="on" style="color:rgba(255,255,255,0.5);">
                                    <v-icon small>mdi-dots-horizontal</v-icon>
                                  </v-btn>
                                </template>
                                <v-list dense>
                                  <v-list-item @click="editarUsuario(usuario)">
                                    <v-list-item-icon class="mr-2"><v-icon small>mdi-pencil</v-icon></v-list-item-icon>
                                    <v-list-item-title>Editar</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="resendWelcomeEmail(usuario)" :disabled="resendingWelcomeId === usuario.id">
                                    <v-list-item-icon class="mr-2">
                                      <v-icon small>mdi-email-arrow-right</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                      <span v-if="resendingWelcomeId === usuario.id">Enviando...</span>
                                      <span v-else>Reenviar e-mail de boas-vindas</span>
                                    </v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="toggleStatusUsuario(usuario)">
                                    <v-list-item-icon class="mr-2">
                                      <v-icon small>{{ usuario.status === 'Ativo' ? 'mdi-account-off' : 'mdi-account-check' }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ usuario.status === 'Ativo' ? 'Desativar' : 'Ativar' }}</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="removerUsuario(usuario)">
                                    <v-list-item-icon class="mr-2"><v-icon small color="red">mdi-delete</v-icon></v-list-item-icon>
                                    <v-list-item-title class="red--text">Remover</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-container>
            </v-tab-item>

            <v-tab-item>
              <v-container fluid class="pa-6">
                <v-tabs v-model="segurancaTab" background-color="transparent" color="#22d3ee" slider-color="#22d3ee" slider-size="3" class="mb-6">
                  <v-tab class="text-capitalize">
                    <v-icon small class="mr-2">mdi-clipboard-text-outline</v-icon>
                    Auditoria
                  </v-tab>
                  <v-tab class="text-capitalize">
                    <v-icon small class="mr-2">mdi-shield-check-outline</v-icon>
                    Políticas
                  </v-tab>
                  <v-tab class="text-capitalize">
                    <v-icon small class="mr-2">mdi-chart-bar</v-icon>
                    Relatórios
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="segurancaTab" style="background:transparent !important;">
                  <v-tab-item>
                    <v-row class="mb-4">
                      <v-col cols="12" sm="6" md="3">
                        <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                          <div class="d-flex align-center">
                            <v-avatar color="rgba(34,211,238,0.15)" size="40" class="mr-3">
                              <v-icon color="#22d3ee">mdi-file-document-multiple</v-icon>
                            </v-avatar>
                            <div>
                              <div class="text-h4 font-weight-bold white--text">{{ auditLogs.length }}</div>
                              <div class="text-caption" style="color:rgba(255,255,255,0.5)">Total de eventos</div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                          <div class="d-flex align-center">
                            <v-avatar color="rgba(239,68,68,0.15)" size="40" class="mr-3">
                              <v-icon color="#F87171">mdi-alert-circle</v-icon>
                            </v-avatar>
                            <div>
                              <div class="text-h4 font-weight-bold white--text">{{ totalEventosCriticos }}</div>
                              <div class="text-caption" style="color:rgba(255,255,255,0.5)">Eventos críticos</div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                          <div class="d-flex align-center">
                            <v-avatar color="rgba(251,191,36,0.15)" size="40" class="mr-3">
                              <v-icon color="#fbbf24">mdi-clock-alert</v-icon>
                            </v-avatar>
                            <div>
                              <div class="text-h4 font-weight-bold white--text">{{ totalAlertas }}</div>
                              <div class="text-caption" style="color:rgba(255,255,255,0.5)">Falhas</div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-card dark outlined class="rounded-lg pa-4" color="#111111">
                          <div class="d-flex align-center">
                            <v-avatar color="rgba(161,161,170,0.15)" size="40" class="mr-3">
                              <v-icon color="#a1a1aa">mdi-account-multiple</v-icon>
                            </v-avatar>
                            <div>
                              <div class="text-h4 font-weight-bold white--text">{{ totalUsuariosUnicos }}</div>
                              <div class="text-caption" style="color:rgba(255,255,255,0.5)">Usuários únicos</div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row class="mb-2">
                      <v-col cols="12" md="6">
                        <v-card outlined dark class="rounded-lg" color="#111111">
                          <v-card-title class="py-4 px-6">
                            <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Atividade de Login</span>
                          </v-card-title>
                          <v-divider></v-divider>
                          <v-card-text class="pa-6">
                            <div style="position: relative; height: 220px;">
                              <canvas ref="loginActivityChart"></canvas>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-card outlined dark class="rounded-lg" color="#111111">
                          <v-card-title class="py-4 px-6">
                            <span class="text-h6 font-weight-medium" style="color: #FFFFFF">Distribuição de Ações</span>
                          </v-card-title>
                          <v-divider></v-divider>
                          <v-card-text class="pa-6">
                            <v-row align="center">
                              <v-col cols="6">
                                <div style="position: relative; height: 200px;">
                                  <canvas ref="acoesDoughnutChart"></canvas>
                                </div>
                              </v-col>
                              <v-col cols="6">
                                <div v-for="item in distribuicaoAcoes" :key="item.label" class="d-flex align-center mb-3">
                                  <div :style="{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: item.cor }" class="mr-2"></div>
                                  <span class="text-body-2 grey--text text--darken-2 mr-2">{{ item.label }}</span>
                                  <v-spacer></v-spacer>
                                  <span class="text-body-2 font-weight-medium">{{ item.percent }}%</span>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-card flat dark class="rounded-lg" color="#111111">
                      <v-card-title class="px-6 pt-5 pb-2">
                        <div>
                          <div class="text-h5 font-weight-bold" style="color: #FFFFFF">Logs de Auditoria</div>
                          <div class="text-body-2" style="color: rgba(255,255,255,0.6)">Histórico completo de ações na plataforma</div>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn outlined @click="exportarLogs" style="color:#d4d4d4; border-color:#2a2a2a;">
                          <v-icon left small>mdi-download</v-icon>
                          Exportar Logs
                        </v-btn>
                      </v-card-title>

                      <v-card-text class="px-6 pb-2">
                        <v-row align="center">
                          <v-col cols="12" sm="4">
                            <v-select
                              v-model="logFiltroPeriodo"
                              :items="['Últimos 7 dias', 'Últimos 15 dias', 'Últimos 30 dias', 'Últimos 90 dias']"
                              filled
                              dense
                              hide-details
                              prepend-inner-icon="mdi-calendar"
                            ></v-select>
                          </v-col>
                          <v-col cols="6" sm="4">
                            <v-select
                              v-model="logFiltroAcao"
                              :items="opcoesAcaoLog"
                              label="Todas as ações"
                              filled
                              dense
                              hide-details
                              clearable
                              prepend-inner-icon="mdi-filter-variant"
                            ></v-select>
                          </v-col>
                          <v-col cols="6" sm="4">
                            <v-select
                              v-model="logFiltroNivel"
                              :items="opcoesNivelLog"
                              label="Todos os níveis"
                              filled
                              dense
                              hide-details
                              clearable
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-card-text>

                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #0d0d0d !important;">
                              <th class="text-left pa-4">Data/Hora</th>
                              <th class="text-left pa-4">Usuário</th>
                              <th class="text-left pa-4">Ação</th>
                              <th class="text-left pa-4">Recurso</th>
                              <th class="text-left pa-4">Detalhes</th>
                              <th class="text-left pa-4">IP</th>
                              <th class="text-center pa-4">Nível</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="log in logsFiltrados" :key="log.id">
                              <td class="pa-4 grey--text text--darken-1" style="white-space: nowrap;">{{ log.dataHora }}</td>
                              <td class="pa-4 font-weight-medium">{{ log.usuario }}</td>
                              <td class="pa-4">
                                <div class="d-flex align-center">
                                  <v-icon small class="mr-2" :color="acaoIconConfig(log.acao).color">{{ acaoIconConfig(log.acao).icon }}</v-icon>
                                  {{ log.acao }}
                                </div>
                              </td>
                              <td class="pa-4">{{ log.recurso }}</td>
                              <td class="pa-4 grey--text text--darken-1">{{ log.detalhes }}</td>
                              <td class="pa-4 grey--text" style="font-family: monospace; font-size: 12px;">{{ log.ip }}</td>
                              <td class="text-center pa-4">
                                <v-chip
                                  :color="nivelChipConfig(log.nivel).bg"
                                  :text-color="nivelChipConfig(log.nivel).text"
                                  small
                                  class="font-weight-medium"
                                >
                                  <v-icon x-small left>{{ nivelChipConfig(log.nivel).icon }}</v-icon>
                                  {{ log.nivel }}
                                </v-chip>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card flat dark class="text-center pa-12" color="transparent">
                      <v-icon size="64" color="rgba(255,255,255,0.15)">mdi-shield-check-outline</v-icon>
                      <h3 class="headline mt-4" style="color:rgba(255,255,255,0.4)">Em desenvolvimento</h3>
                      <p class="mt-2" style="color:rgba(255,255,255,0.3)">Gerenciamento de políticas de segurança estará disponível em breve.</p>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card flat dark class="text-center pa-12" color="transparent">
                      <v-icon size="64" color="rgba(255,255,255,0.15)">mdi-chart-bar</v-icon>
                      <h3 class="headline mt-4" style="color:rgba(255,255,255,0.4)">Em desenvolvimento</h3>
                      <p class="mt-2" style="color:rgba(255,255,255,0.3)">Relatórios de segurança estarão disponíveis em breve.</p>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-container>
    </v-main>

    <v-dialog v-model="dialogConvidarUsuario" max-width="520" persistent>
      <v-card dark class="rounded-lg ta-invite-dialog" color="#111111" style="position:relative;">
        <v-card-title class="ta-invite-dialog__header">
          <div>
            <div class="text-h6 font-weight-bold white--text">Convidar Usuário</div>
            <div class="text-caption ta-invite-dialog__subtitle">Envie um convite por e-mail</div>
          </div>
        </v-card-title>
        <v-btn icon :ripple="false" @click="fecharDialogConvite" class="ta-invite-dialog__close" style="position:absolute;top:12px;right:12px;z-index:1;"><v-icon size="18">mdi-close</v-icon></v-btn>
        <v-card-text class="ta-invite-dialog__body">
          <v-text-field
            v-model="conviteForm.nome"
            label="Nome completo"
            placeholder="Ex.: Maria Silva"
            outlined
            dark
            hide-details="auto"
            class="mb-4 ta-invite-field"
          ></v-text-field>
          <v-text-field
            v-model="conviteForm.email"
            label="E-mail"
            placeholder="nome@empresa.com"
            outlined
            dark
            hide-details="auto"
            class="mb-4 ta-invite-field"
          ></v-text-field>
          <v-select
            v-model="conviteForm.perfil"
            :items="['Admin', 'Gestor', 'Colaborador']"
            label="Perfil"
            outlined
            dark
            hide-details="auto"
            class="ta-invite-field"
          ></v-select>
        </v-card-text>
        <v-card-actions class="ta-invite-dialog__footer">
          <v-spacer></v-spacer>
          <v-btn outlined class="ta-invite-cancel" @click="fecharDialogConvite">Cancelar</v-btn>
          <v-btn color="#1196AD" dark elevation="0" :loading="enviandoConvite" @click="enviarConvite" class="ta-invite-submit">
            <v-icon left small>mdi-send-outline</v-icon>
            Enviar Convite
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConector" max-width="520" persistent>
      <v-card class="rounded-lg" v-if="conectorSelecionado">
        <v-card-title class="pb-1">
          <v-icon :color="conectorSelecionado.iconColor" class="mr-3">{{ conectorSelecionado.icon }}</v-icon>
          <div>
            <div class="text-h6 font-weight-bold">Configurar {{ conectorSelecionado.nome }}</div>
            <div class="text-caption grey--text">Preencha as credenciais para conectar</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharDialogConector">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4 pb-2">
          <div v-for="campo in conectorSelecionado.campos" :key="campo.key" class="mb-4">
            <div class="d-flex align-center mb-1">
              <span class="text-body-2 font-weight-medium grey--text text--darken-3">{{ campo.label }}</span>
              <v-spacer></v-spacer>
              <a
                v-if="campo.helpLink"
                :href="campo.helpLink"
                target="_blank"
                class="text-caption success--text text-decoration-none font-weight-medium"
              >
                {{ campo.helpText }} <v-icon x-small color="success">mdi-open-in-new</v-icon>
              </a>
            </div>
            <v-text-field
              v-model="conectorForm[campo.key]"
              :placeholder="campo.placeholder"
              :type="campo.type || 'text'"
              filled
              hide-details="auto"
            ></v-text-field>
          </div>

          <v-alert dense text type="info" color="grey" class="text-caption mt-2 mb-0">
            <v-icon small left color="grey">mdi-shield-check</v-icon>
            Suas credenciais são criptografadas e armazenadas de forma segura. Nunca compartilhamos seus dados com terceiros.
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4 pt-2">
          <v-spacer></v-spacer>
          <v-btn outlined color="grey darken-1" @click="fecharDialogConector">
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            :loading="salvandoConector"
            @click="salvarConector"
          >
            Salvar e Conectar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="githubSetupDialog" max-width="520" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="pb-1">
          <v-icon color="grey darken-4" class="mr-3">mdi-github</v-icon>
          <div>
            <div class="text-h6 font-weight-bold">Configurar GitHub</div>
            <div class="text-caption grey--text">Informe os dados da sua conta GitHub</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharGithubSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4 pb-2">
          <v-alert
            v-if="githubSetupIsReconnect"
            dense
            text
            type="info"
            color="blue"
            class="text-caption mb-4"
          >
            <v-icon small left color="blue">mdi-information</v-icon>
            Reconectando integração anterior. Você pode alterar os dados se necessário.
          </v-alert>

          <div class="mb-4">
            <div class="d-flex align-center mb-1">
              <span class="text-body-2 font-weight-medium grey--text text--darken-3">Login do GitHub *</span>
              <v-spacer></v-spacer>
              <a
                href="https://github.com/settings/profile"
                target="_blank"
                class="text-caption success--text text-decoration-none font-weight-medium"
              >
                Ver meu login <v-icon x-small color="success">mdi-open-in-new</v-icon>
              </a>
            </div>
            <v-text-field
              v-model="githubSetupForm.accountLogin"
              placeholder="Ex: minha-empresa ou meu-usuario"
              filled
              hide-details="auto"
              hint="Nome da organização ou usuário no GitHub"
              persistent-hint
            ></v-text-field>
          </div>

          <div class="mb-4">
            <div class="d-flex align-center mb-1">
              <span class="text-body-2 font-weight-medium grey--text text--darken-3">Account ID (opcional)</span>
              <v-spacer></v-spacer>
              <a
                href="https://api.github.com/users/"
                target="_blank"
                class="text-caption success--text text-decoration-none font-weight-medium"
              >
                Como obter <v-icon x-small color="success">mdi-open-in-new</v-icon>
              </a>
            </div>
            <v-text-field
              v-model="githubSetupForm.accountId"
              placeholder="Ex: 12345678"
              filled
              hide-details="auto"
              hint="ID numérico da conta (opcional)"
              persistent-hint
              type="number"
            ></v-text-field>
          </div>

          <v-alert dense text type="info" color="primary" class="text-caption mt-2 mb-0">
            <v-icon small left color="primary">mdi-information</v-icon>
            Após clicar em "Continuar", você será redirecionado para autorizar o acesso do aplicativo no GitHub.
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4 pt-2">
          <v-spacer></v-spacer>
          <v-btn outlined color="grey darken-1" @click="fecharGithubSetupDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="grey darken-4"
            dark
            elevation="0"
            :loading="salvandoGithubSetup"
            :disabled="!githubSetupForm.accountLogin || githubSetupForm.accountLogin.trim() === ''"
            @click="confirmarGithubSetup"
          >
            <v-icon left small>mdi-github</v-icon>
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Editar Usuário -->
    <v-dialog v-model="dialogEditarUsuario" max-width="500" persistent>
      <v-card dark class="rounded-lg ta-invite-dialog" color="#111111" style="position:relative;">
        <!-- Header -->
        <v-card-title class="ta-invite-dialog__header">
          <div>
            <div class="text-h6 font-weight-bold white--text">Editar Usuário</div>
            <div class="text-caption ta-invite-dialog__subtitle">Atualize os dados do usuário</div>
          </div>
        </v-card-title>
        <v-btn icon :ripple="false" @click="fecharDialogEditar" class="ta-invite-dialog__close" style="position:absolute;top:12px;right:12px;z-index:1;"><v-icon size="18">mdi-close</v-icon></v-btn>

        <v-card-text class="ta-invite-dialog__body">
          <!-- Avatar + nome display -->
          <div class="d-flex align-center mb-5">
            <v-avatar :color="editarForm.avatarUrl ? 'transparent' : 'rgba(34,211,238,0.15)'" size="48" class="mr-4">
              <v-img v-if="editarForm.avatarUrl" :src="editarForm.avatarUrl" />
              <span v-else class="font-weight-bold" style="color:#22d3ee; font-size:16px;">{{ editarForm.iniciais }}</span>
            </v-avatar>
            <div>
              <div class="font-weight-bold white--text">{{ editarForm.nome || 'Usuário' }}</div>
              <div class="text-caption" style="color:rgba(255,255,255,0.45)">{{ editarForm.email }}</div>
            </div>
          </div>

          <v-text-field
            v-model="editarForm.nome"
            label="Nome completo"
            outlined
            dark
            hide-details="auto"
            class="mb-4 ta-invite-field"
          ></v-text-field>

          <v-text-field
            v-model="editarForm.email"
            label="E-mail"
            outlined
            dark
            hide-details="auto"
            class="mb-4 ta-invite-field"
          ></v-text-field>

          <v-row no-gutters class="mb-4" style="gap:12px;">
            <v-col>
              <v-select
                v-model="editarForm.perfil"
                :items="opcoesPerfil"
                label="Perfil"
                outlined
                dark
                hide-details="auto"
                class="ta-invite-field"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="editarForm.status"
                :items="opcoesStatus"
                label="Status"
                outlined
                dark
                hide-details="auto"
                class="ta-invite-field"
              ></v-select>
            </v-col>
          </v-row>

          <v-select
            v-model="editarForm.departamento"
            :items="departamentos"
            label="Departamento"
            outlined
            dark
            hide-details="auto"
            class="ta-invite-field"
          ></v-select>
        </v-card-text>

        <!-- Ações -->
        <v-card-actions class="ta-invite-dialog__footer">
          <v-spacer></v-spacer>
          <v-btn outlined class="ta-invite-cancel" :disabled="editarLoading" @click="fecharDialogEditar">Cancelar</v-btn>
          <v-btn
            elevation="0"
            :loading="editarLoading"
            @click="salvarEdicaoUsuario"
            class="ta-invite-submit"
            style="background-color:#22d3ee; color:#06222b; font-weight:700;"
          >
            <v-icon left small>mdi-check</v-icon>
            Salvar Alterações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" top>
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script>
import TenantSettingsService from '@/services/tenant-settings.service'
import BillingService from '@/services/billing.service'
import IntegrationsService from '@/services/integrations.service'
import TenantUsersService from '@/services/tenant-users.service'
import SecurityService from '@/services/security.service'

export default {
  name: 'TenantSettings',
  
  data() {
    return {
      activeTab: 0,
      salvando: false,
      resendingWelcomeId: null,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      
      tenantData: {
        razaoSocial: '',
        nomeFantasia: '',
        cnpj: '',
        setor: '',
        telefone: '',
        email: '',
        endereco: '',
        website: '',
        porteEmpresa: ''
      },
      
      responsavelData: {
        nomeCompleto: '',
        cargo: '',
        email: '',
        telefone: ''
      },
      
      contratoData: {
        dataInicio: '',
        dataTermino: '',
        plano: '',
        formaPagamento: '',
        observacoes: ''
      },
      
      acessoData: {
        permitirCadastroNovosUsuarios: false,
        autenticacaoDoisFatores: false,
        singleSignOn: false
      },
      
      setores: [
        'Tecnologia',
        'Educação',
        'Saúde',
        'Financeiro',
        'Varejo',
        'Indústria',
        'Serviços',
        'Outro'
      ],
      
      portesEmpresa: [
        'MEI',
        'ME',
        'EPP',
        'Média',
        'Grande',
      ],
      
      planos: [
        'Básico',
        'Profissional',
        'Enterprise',
        'Corporativo'
      ],
      
      formasPagamento: [
        'Boleto Bancário',
        'Cartão de Crédito',
        'Transferência Bancária',
        'PIX'
      ],
      
      // --- Financeiro ---
      baixandoPDF: false,
      pagando: false,
      evolucaoPeriodo: '6 meses',
      financeiroData: {
        usuariosAtivos: 0,
        usuariosTotais: 0,
        custoUsuario: 0,
        crescimentoPercent: 0,
        fatura: {
          id: null,
          mesReferencia: '',
          vencimento: '',
          status: '',
          descontoPercent: 0,
          itens: []
        }
      },

      custoDepartamentos: [],

      evolucaoUsuarios: [],

      historicoFaturas: [],

      distribuicaoUsuarios: [],

      evolucaoChartInstance: null,

      // --- Usuários ---
      buscaUsuario: '',
      filtroPerfil: null,
      filtroStatus: null,
      dialogConvidarUsuario: false,
      enviandoConvite: false,
      conviteForm: { nome: '', email: '', perfil: 'Colaborador' },
      opcoesPerfil: ['Admin', 'Gestor', 'Colaborador'],
      opcoesStatus: ['Ativo', 'Inativo'],
      departamentos: ['TI', 'Engenharia', 'Produto', 'Design', 'Marketing', 'Vendas', 'RH', 'Financeiro'],
      usuariosPlataforma: [],
      dialogEditarUsuario: false,
      editarLoading: false,
      editarForm: { id: null, nome: '', email: '', perfil: 'Colaborador', status: 'Ativo', departamento: '', avatarUrl: null, iniciais: '' },

      // --- Segurança ---
      segurancaTab: 0,
      logFiltroPeriodo: 'Últimos 7 dias',
      logFiltroAcao: null,
      logFiltroNivel: null,
      opcoesAcaoLog: ['Login', 'Logout', 'Edição', 'Configuração', 'Visualização', 'Exportação', 'Exclusão', 'Criação'],
      opcoesNivelLog: ['Info', 'Atenção', 'Crítico'],
      loginActivityChartInstance: null,
      acoesDoughnutChartInstance: null,
      distribuicaoAcoes: [],
      loginActivityData: {
        labels: [],
        logins: [],
        logouts: []
      },
      auditLogs: [],

      // Mock: conectores
      dialogConector: false,
      conectorSelecionado: null,
      conectorForm: {},
      salvandoConector: false,

      // GitHub Setup Dialog
      githubSetupDialog: false,
      githubSetupForm: {
        accountLogin: '',
        accountId: ''
      },
      githubSetupIsReconnect: false, // Flag para indicar reconexão
      githubPreviousStatus: null, // Armazena status anterior (para saber se é DELETED)
      salvandoGithubSetup: false,

      conectores: [
        {
          id: 'jira',
          nome: 'Jira',
          icon: 'mdi-jira',
          iconColor: '#2684ff',
          descricao: 'Integre com Jira Cloud para sincronizar tarefas e métricas de projeto.',
          conectado: false,
          loading: false,
          campos: [] // Jira usa OAuth flow, sem campos de formulário
        },
        {
          id: 'github',
          nome: 'GitHub',
          icon: 'mdi-github',
          iconColor: '#f5f5f5',
          descricao: 'Conecte repositórios GitHub para métricas de PRs e commits.',
          conectado: false,
          loading: false,
          campos: [] // GitHub usa OAuth flow, sem campos de formulário
        },
        {
          id: 'azure-devops',
          nome: 'Azure DevOps',
          icon: 'mdi-microsoft-azure-devops',
          iconColor: '#0078d7',
          descricao: 'Integre com Azure DevOps para boards, repos e pipelines.',
          conectado: false,
          loading: false,
          campos: [] // Usa OAuth flow via Microsoft Graph
        },
        {
          id: 'aws',
          nome: 'AWS',
          icon: 'mdi-aws',
          iconColor: '#ff9900',
          descricao: 'Conecte à AWS para métricas de infraestrutura e CodeCommit.',
          conectado: false,
          loading: false,
          campos: [
            { key: 'accessKeyId', label: 'Access Key ID', placeholder: 'AKIAIOSFODNN7EXAMPLE' },
            { key: 'secretAccessKey', label: 'Secret Access Key', placeholder: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY', type: 'password' },
            { key: 'regiao', label: 'Região', placeholder: 'us-east-1' }
          ]
        },
        {
          id: 'bitbucket',
          nome: 'Bitbucket',
          icon: 'mdi-bitbucket',
          iconColor: '#2684ff',
          descricao: 'Integre com Bitbucket Cloud para repositórios e pull requests.',
          conectado: false,
          loading: false,
          campos: [
            { key: 'workspace', label: 'Workspace', placeholder: 'seu-workspace' },
            { key: 'username', label: 'Usuário', placeholder: 'seu-usuario' },
            { key: 'appPassword', label: 'App Password', placeholder: 'Senha de app do Bitbucket', type: 'password', helpText: 'Como obter', helpLink: 'https://support.atlassian.com/bitbucket-cloud/docs/app-passwords/' }
          ]
        }
      ]
    }
  },
  
  computed: {
    userEmail() {
      if (this.$store.state.user && this.$store.state.user.email) {
        return this.$store.state.user.email
      }
      try {
        const stored = JSON.parse(localStorage.getItem('user'))
        if (stored && stored.email) return stored.email
      } catch (e) { /* ignore */ }
      return ''
    },
    
    diasRestantes() {
      if (!this.contratoData.dataTermino) return 0
      const termino = new Date(this.contratoData.dataTermino)
      const hoje = new Date()
      const diff = Math.ceil((termino - hoje) / (1000 * 60 * 60 * 24))
      return diff
    },
    
    diasRestantesColor() {
      const dias = this.diasRestantes
      if (dias < 0) return 'error' // Vencido
      if (dias <= 30) return 'warning' // Crítico
      if (dias <= 60) return 'orange' // Atenção
      return 'success' // OK
    },
    
    diasRestantesIcon() {
      if (this.diasRestantes < 0) return 'mdi-alert-circle'
      if (this.diasRestantes <= 30) return 'mdi-alert'
      return 'mdi-check-circle'
    },

    // --- Financeiro computed ---
    faturaSubtotal() {
      return this.financeiroData.fatura.itens.reduce((sum, item) => {
        return sum + (item.quantidade * item.valorUnitario)
      }, 0)
    },

    faturaDesconto() {
      return this.faturaSubtotal * (this.financeiroData.fatura.descontoPercent / 100)
    },

    faturaAtualTotal() {
      return this.faturaSubtotal - this.faturaDesconto
    },

    statusFaturaColor() {
      const map = {
        'Pendente': '#3a2708',
        'Paga':     '#16351f',
        'Vencida':  '#7f1d1d'
      }
      return map[this.financeiroData.fatura.status] || '#1f1f1f'
    },

    statusFaturaTextColor() {
      const map = {
        'Pendente': '#fbbf24',
        'Paga':     '#4ade80',
        'Vencida':  '#fca5a5'
      }
      return map[this.financeiroData.fatura.status] || '#888888'
    },

    custoMaxDepartamento() {
      return Math.max(...this.custoDepartamentos.map(d => d.custo))
    },

    totalUsuariosDistribuicao() {
      return this.distribuicaoUsuarios.reduce((s, g) => s + g.quantidade, 0)
    },

    // --- Usuários computed ---
    totalAdmins() {
      return this.usuariosPlataforma.filter(u => u.perfil === 'Admin').length
    },
    totalGestores() {
      return this.usuariosPlataforma.filter(u => u.perfil === 'Gestor').length
    },
    totalColaboradores() {
      return this.usuariosPlataforma.filter(u => u.perfil === 'Colaborador').length
    },
    totalAtivos() {
      return this.usuariosPlataforma.filter(u => u.status === 'Ativo').length
    },
    usuariosFiltrados() {
      let lista = this.usuariosPlataforma
      if (this.buscaUsuario) {
        const q = this.buscaUsuario.toLowerCase()
        lista = lista.filter(u => u.nome.toLowerCase().includes(q) || u.email.toLowerCase().includes(q))
      }
      if (this.filtroPerfil) {
        lista = lista.filter(u => u.perfil === this.filtroPerfil)
      }
      if (this.filtroStatus) {
        lista = lista.filter(u => u.status === this.filtroStatus)
      }
      return lista
    },

    // --- Segurança computed ---
    totalEventosCriticos() {
      return this.auditLogs.filter(l => l.nivel === 'Crítico').length
    },
    totalAlertas() {
      return this.auditLogs.filter(l => l.nivel === 'Atenção').length
    },
    totalUsuariosUnicos() {
      return new Set(this.auditLogs.map(l => l.usuario)).size
    },
    logsFiltrados() {
      let lista = this.auditLogs
      if (this.logFiltroAcao) {
        lista = lista.filter(l => l.acao === this.logFiltroAcao)
      }
      if (this.logFiltroNivel) {
        lista = lista.filter(l => l.nivel === this.logFiltroNivel)
      }
      return lista
    }
  },
  
  watch: {
    activeTab(val) {
      if (val === 1) {
        this.carregarFinanceiro()
      }
      if (val === 2) {
        this.carregarConectoresDoBackend()
      }
      if (val === 4) {
        this.carregarSeguranca()
      }
    },
    evolucaoPeriodo() {
      this.$nextTick(() => this.renderEvolucaoChart())
    },
    segurancaTab(val) {
      if (val === 0 && this.activeTab === 4) {
        this.$nextTick(() => {
          this.renderLoginActivityChart()
          this.renderAcoesDoughnutChart()
        })
      }
    }
  },

  mounted() {
    console.log('✅ TenantSettings montado com sucesso')
    console.log('User:', this.$store.state.user)
    console.log('TenantId from store:', this.$store.state.user?.tenantId)
    console.log('TenantId from localStorage:', localStorage.getItem('tenantId'))
    this.carregarConfiguracoes()
    this.carregarUsuarios()
    this.carregarConectoresDoBackend()
  },

  beforeDestroy() {
    if (this.evolucaoChartInstance) {
      this.evolucaoChartInstance.destroy()
    }
    if (this.loginActivityChartInstance) {
      this.loginActivityChartInstance.destroy()
    }
    if (this.acoesDoughnutChartInstance) {
      this.acoesDoughnutChartInstance.destroy()
    }
  },
  
  methods: {
    logout() {
      // Remove todos os dados de autenticação do localStorage
      localStorage.removeItem('firebaseToken')
      localStorage.removeItem('user')
      localStorage.removeItem('tenantId')
      localStorage.removeItem('backendToken')
      
      // Redireciona para a tela de login
      this.$router.push('/login')
    },

    voltarDashboard() {
      this.$router.push('/tenant-admin')
    },
    
    async carregarConfiguracoes() {
      try {
        const tenantId = this.$store.state.user?.tenantId || localStorage.getItem('tenantId')
        if (!tenantId) {
          console.warn('⚠️ tenantId não encontrado')
          return
        }

        const response = await TenantSettingsService.getTenantById(tenantId)
        const data = response.data

        // Mapear companyData → tenantData
        if (data.companyData) {
          this.tenantData = { ...this.tenantData, ...data.companyData }
        }
        // Mapear contractResponsible → responsavelData
        // Se o objeto existe mas todos os campos são nulos, preencher com dados do usuário logado
        const cr = data.contractResponsible
        const crTemDados = cr && Object.values(cr).some(v => v !== null && v !== '')
        if (crTemDados) {
          this.responsavelData = { ...this.responsavelData, ...cr }
        } else {
          // Fallback: adminName/adminEmail vindos do próprio tenant (campo top-level)
          // + dados do usuário logado no localStorage
          const storedUser = JSON.parse(localStorage.getItem('user') || '{}')
          this.responsavelData = {
            nomeCompleto: data.adminName || storedUser.name || storedUser.displayName || '',
            cargo: storedUser.cargo || (storedUser.role === 'TENANT_ADMIN' ? 'Admin' : storedUser.role) || '',
            email: data.adminEmail || storedUser.email || '',
            telefone: storedUser.phone || storedUser.telefone || '',
          }
        }
        // Mapear contractInfo → contratoData
        if (data.contractInfo) {
          this.contratoData = { ...this.contratoData, ...data.contractInfo }
        }
        // dataInicio sempre vem do createdAt do tenant
        if (data.createdAt) {
          this.contratoData.dataInicio = data.createdAt.substring(0, 10)
        }
        // Mapear accessConfig → acessoData
        if (data.accessConfig) {
          this.acessoData = { ...this.acessoData, ...data.accessConfig }
        }
        
        console.log('✅ Configurações carregadas do backend (GET /api/tenants/' + tenantId + ')')
      } catch (error) {
        console.error('Erro ao carregar configurações:', error)
        this.$store.dispatch('showSnackbar', {
          text: 'Erro ao carregar configurações.',
          color: 'error'
        })
      }
    },
    
    async salvarConfiguracoes() {
      this.salvando = true
      try {
        const tenantId = this.$store.state.user?.tenantId || localStorage.getItem('tenantId')
        const payload = {
          companyData: this.tenantData,
          contractResponsible: this.responsavelData,
          contractInfo: {
            plano: this.contratoData.plano,
            formaPagamento: this.contratoData.formaPagamento,
            observacoes: this.contratoData.observacoes
          },
          accessConfig: this.acessoData
        }
        
        const response = await TenantSettingsService.updateTenant(tenantId, payload)
        const data = response.data
        
        // Atualizar com dados retornados pelo backend
        if (data.companyData) {
          this.tenantData = { ...this.tenantData, ...data.companyData }
        }
        if (data.contractInfo) {
          // Preservar dataInicio (vem do createdAt, não do contractInfo do backend)
          const dataInicio = this.contratoData.dataInicio
          this.contratoData = { ...this.contratoData, ...data.contractInfo }
          if (dataInicio) this.contratoData.dataInicio = dataInicio
        }
        
        this.snackbarText = 'Configurações salvas com sucesso!'
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao salvar:', error)
        const msg = error.response?.data?.error || 'Erro ao salvar configurações'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        this.salvando = false
      }
    },

    // --- Financeiro methods ---
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    },

    async carregarFinanceiro() {
      try {
        const [summaryRes, invoiceRes, historyRes] = await Promise.all([
          BillingService.getResumo(),
          BillingService.getFaturaAtual(),
          BillingService.getHistoricoFaturas()
        ])
        
        const summary = summaryRes.data.data || summaryRes.data
        if (summary) {
          this.financeiroData = {
            ...this.financeiroData,
            usuariosAtivos: summary.usuariosAtivos || 0,
            usuariosTotais: summary.usuariosTotais || 0,
            custoUsuario: summary.custoUsuario || 0,
            crescimentoPercent: summary.crescimentoPercent || 0
          }
          if (summary.custoDepartamentos) this.custoDepartamentos = summary.custoDepartamentos
          if (summary.evolucaoUsuarios) this.evolucaoUsuarios = summary.evolucaoUsuarios
          if (summary.distribuicaoUsuarios) this.distribuicaoUsuarios = summary.distribuicaoUsuarios
        }
        
        const invoice = invoiceRes.data.data || invoiceRes.data
        if (invoice) {
          this.financeiroData.fatura = { ...this.financeiroData.fatura, ...invoice }
        }
        
        const history = historyRes.data.data || historyRes.data
        if (history) {
          this.historicoFaturas = history.content || history || []
        }
        
        console.log('✅ Dados financeiros carregados')
        this.$nextTick(() => this.renderEvolucaoChart())
      } catch (error) {
        console.error('Erro ao carregar dados financeiros:', error)
      }
    },

    async baixarFaturaPDF() {
      this.baixandoPDF = true
      try {
        const faturaId = this.financeiroData.fatura.id
        if (!faturaId) {
          this.snackbarText = 'Fatura sem ID disponível'
          this.snackbarColor = 'warning'
          this.snackbar = true
          return
        }
        const response = await BillingService.downloadPDF(faturaId)
        
        // Criar link de download
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `fatura-${faturaId}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        
        this.snackbarText = 'PDF da fatura baixado com sucesso!'
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao baixar PDF:', error)
        this.snackbarText = 'Erro ao baixar PDF da fatura'
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        this.baixandoPDF = false
      }
    },

    async pagarFatura() {
      this.pagando = true
      try {
        const faturaId = this.financeiroData.fatura.id
        const response = await BillingService.pagarFatura(faturaId, { metodo: this.contratoData.formaPagamento || 'Boleto Bancário' })
        const data = response.data.data || response.data
        
        this.financeiroData.fatura.status = 'Paga'
        this.snackbarText = 'Pagamento realizado com sucesso!'
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao processar pagamento:', error)
        const msg = error.response?.data?.error || 'Erro ao processar pagamento'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        this.pagando = false
      }
    },

    renderEvolucaoChart() {
      const canvas = this.$refs.evolucaoChart
      if (!canvas) return

      // Importação dinâmica do Chart.js
      const Chart = require('chart.js')

      if (this.evolucaoChartInstance) {
        this.evolucaoChartInstance.destroy()
      }

      const labels = this.evolucaoUsuarios.map(e => e.mes)
      const data = this.evolucaoUsuarios.map(e => e.valor)

      this.evolucaoChartInstance = new Chart(canvas.getContext('2d'), {
        type: 'line',
        data: {
          labels,
          datasets: [{
            label: 'Usuários',
            data,
            borderColor: '#4CAF50',
            backgroundColor: 'rgba(76, 175, 80, 0.1)',
            borderWidth: 2,
            pointBackgroundColor: '#4CAF50',
            pointRadius: 4,
            fill: true,
            tension: 0.3
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: false,
                callback: v => v
              },
              gridLines: { drawBorder: false, color: 'rgba(0,0,0,0.05)' }
            }],
            xAxes: [{
              gridLines: { display: false }
            }]
          },
          tooltips: {
            callbacks: {
              label: item => `${item.yLabel} usuários`
            }
          }
        }
      })
    },

    async baixarFaturaHistorico(faturaId) {
      try {
        const response = await BillingService.downloadPDF(faturaId)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `fatura-${faturaId}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        this.snackbarText = `PDF da fatura ${faturaId} baixado!`
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao baixar PDF:', error)
        this.snackbarText = 'Erro ao baixar PDF da fatura'
        this.snackbarColor = 'error'
        this.snackbar = true
      }
    },

    async exportarRelatorio() {
      try {
        const response = await BillingService.getResumo()
        const data = response.data.data || response.data
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `relatorio-financeiro-${new Date().toISOString().split('T')[0]}.json`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        this.snackbarText = 'Relatório exportado com sucesso!'
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao exportar relatório:', error)
        this.snackbarText = 'Erro ao exportar relatório'
        this.snackbarColor = 'error'
        this.snackbar = true
      }
    },

    // --- Conectores methods ---
    conectarIntegracao(conector) {
      // GitHub usa OAuth flow especial
      if (conector.id === 'github') {
        this.conectarGithub(conector)
        return
      }

      // Jira usa OAuth flow especial
      if (conector.id === 'jira') {
        this.conectarJira(conector)
        return
      }

      // Microsoft / Azure DevOps usa OAuth flow
      if (conector.id === 'azure-devops') {
        this.conectarMicrosoft(conector)
        return
      }

      // Outros conectores usam formulário padrão
      this.conectorSelecionado = conector
      this.conectorForm = {}
      conector.campos.forEach(c => {
        this.$set(this.conectorForm, c.key, '')
      })
      this.dialogConector = true
    },

    fecharDialogConector() {
      this.dialogConector = false
      this.conectorSelecionado = null
      this.conectorForm = {}
    },

    async salvarConector() {
      this.salvandoConector = true
      try {
        await IntegrationsService.connect(this.conectorSelecionado.id, this.conectorForm)
        this.conectorSelecionado.conectado = true
        this.snackbarText = `${this.conectorSelecionado.nome} conectado com sucesso!`
        this.snackbarColor = 'success'
        this.snackbar = true
        this.fecharDialogConector()
      } catch (error) {
        console.error(`Erro ao conectar ${this.conectorSelecionado.nome}:`, error)
        const msg = error.response?.data?.error || `Erro ao conectar ${this.conectorSelecionado.nome}`
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        this.salvandoConector = false
      }
    },

    async desconectarIntegracao(conector) {
      // GitHub usa endpoint específico
      if (conector.id === 'github') {
        await this.desconectarGithub(conector)
        return
      }

      // Jira usa endpoint específico
      if (conector.id === 'jira') {
        await this.desconectarJira(conector)
        return
      }

      // Microsoft / Azure DevOps usa endpoint específico
      if (conector.id === 'azure-devops') {
        await this.desconectarMicrosoft(conector)
        return
      }

      // Outros conectores usam endpoint padrão
      conector.loading = true
      try {
        await IntegrationsService.disconnect(conector.id)
        conector.conectado = false
        this.snackbarText = `${conector.nome} desconectado`
        this.snackbarColor = 'info'
        this.snackbar = true
      } catch (error) {
        console.error(`Erro ao desconectar ${conector.nome}:`, error)
        const msg = error.response?.data?.error || `Erro ao desconectar ${conector.nome}`
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        conector.loading = false
      }
    },

    // === GitHub OAuth Flow ===
    async conectarGithub(conector) {
      // Verificar se já existe integração anterior (mesmo que DELETED)
      try {
        const statusResponse = await IntegrationsService.getGithubStatus()
        const status = statusResponse.data
        
        // Armazenar status completo para usar depois
        this.githubPreviousStatus = status
        
        // Pré-preencher formulário com dados existentes (se houver)
        this.githubSetupForm = {
          accountLogin: status.accountLogin || '',
          accountId: status.accountId ? String(status.accountId) : ''
        }
        
        // Marcar como reconexão se status for DELETED
        this.githubSetupIsReconnect = status.status === 'DELETED'
        
        if (status.status === 'DELETED') {
          console.log('🔄 Reconectando integração anterior (DELETED):', status.accountLogin)
        } else if (status.accountLogin) {
          console.log('ℹ️ Dados encontrados:', status.accountLogin)
        }
      } catch (error) {
        // Se não houver integração anterior, apenas inicializar vazio
        console.log('ℹ️ Nenhuma integração anterior encontrada')
        this.githubSetupForm = {
          accountLogin: '',
          accountId: ''
        }
        this.githubSetupIsReconnect = false
        this.githubPreviousStatus = null
      }
      
      // Abrir dialog para coletar/confirmar accountLogin e accountId
      this.githubSetupDialog = true
      // conector será passado via this para confirmarGithubSetup
      this.conectorSelecionado = conector
    },

    fecharGithubSetupDialog() {
      this.githubSetupDialog = false
      this.githubSetupForm = {
        accountLogin: '',
        accountId: ''
      }
      this.githubSetupIsReconnect = false
      this.githubPreviousStatus = null
      this.conectorSelecionado = null
    },

    async confirmarGithubSetup() {
      const conector = this.conectorSelecionado
      if (!conector) return

      // Validar campos
      if (!this.githubSetupForm.accountLogin || this.githubSetupForm.accountLogin.trim() === '') {
        this.snackbarText = 'Login do GitHub é obrigatório'
        this.snackbarColor = 'warning'
        this.snackbar = true
        return
      }

      this.salvandoGithubSetup = true
      conector.loading = true

      try {
        const accountLogin = this.githubSetupForm.accountLogin.trim()
        const accountId = this.githubSetupForm.accountId.trim() || null
        
        // Verificar se é reconexão (status DELETED) ou nova instalação
        const isReconnect = this.githubPreviousStatus?.status === 'DELETED'
        
        if (isReconnect) {
          console.log('🔄 Reconectando GitHub (status DELETED)...')
          
          // Chamar endpoint de reconnect
          const reconnectResponse = await IntegrationsService.reconnectGithub(accountLogin, accountId)
          const reconnectData = reconnectResponse.data
          
          console.log('✅ Response do reconnect:', reconnectData)
          
          // Fechar dialog de setup
          this.fecharGithubSetupDialog()
          
          // Verificar se já está ACTIVE (app ainda instalado) ou PENDING (precisa instalar)
          if (reconnectData.status === 'ACTIVE') {
            // Sucesso direto! App ainda está instalado no GitHub
            console.log('🎉 Reconexão imediata - App ainda instalado!')
            conector.conectado = true
            conector.loading = false
            
            this.snackbarText = `GitHub reconectado com sucesso! Conta: ${reconnectData.accountLogin}`
            this.snackbarColor = 'success'
            this.snackbar = true
            
            return // Não precisa de OAuth flow
          } else {
            // Status PENDING - precisa autorizar novamente
            console.log('⚠️ App não está mais instalado, iniciando OAuth flow...')
            const installUrl = reconnectData.installUrl
            
            // Abrir janela de autorização do GitHub
            const authWindow = this.abrirJanelaOAuth(installUrl)
            
            if (!authWindow) {
              throw new Error('Popup bloqueado. Permita popups para este site.')
            }
            
            this.snackbarText = 'Autorize o acesso no GitHub...'
            this.snackbarColor = 'info'
            this.snackbar = true
            
            // Polling para verificar se integração foi concluída
            await this.aguardarConexaoGithub(conector, authWindow)
          }
        } else {
          // Nova instalação
          console.log('🔗 Iniciando nova instalação GitHub...')
          
          const initResponse = await IntegrationsService.initGithubInstallation(accountLogin, accountId)
          const { installUrl, accountLogin: responseLogin, status } = initResponse.data
          
          console.log('✅ Integração pendente criada:', { accountLogin: responseLogin, status })
          
          // Fechar dialog de setup
          this.fecharGithubSetupDialog()
          
          // Abrir janela de autorização do GitHub
          const authWindow = this.abrirJanelaOAuth(installUrl)
          
          if (!authWindow) {
            throw new Error('Popup bloqueado. Permita popups para este site.')
          }
          
          this.snackbarText = 'Autorize o acesso no GitHub...'
          this.snackbarColor = 'info'
          this.snackbar = true
          
          // Polling para verificar se integração foi concluída
          await this.aguardarConexaoGithub(conector, authWindow)
        }
        
      } catch (error) {
        console.error('❌ Erro ao conectar GitHub:', error)
        const msg = error.response?.data?.error || error.message || 'Erro ao conectar GitHub'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
        conector.loading = false
        this.salvandoGithubSetup = false
      } finally {
        this.salvandoGithubSetup = false
      }
    },

    abrirJanelaOAuth(installUrl) {
      const width = 600
      const height = 700
      const left = (window.screen.width - width) / 2
      const top = (window.screen.height - height) / 2
      
      return window.open(
        installUrl,
        'GitHub Authorization',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
      )
    },

    async aguardarConexaoGithub(conector, authWindow) {
      // Fazer polling até que integração seja concluída ou janela seja fechada
      let tentativas = 0
      const maxTentativas = 60 // 60 tentativas = 1 minuto (1s interval)
      
      const checkStatus = async () => {
        try {
          // Verificar se janela foi fechada
          if (authWindow.closed) {
            console.log('⚠️ Janela de autorização fechada')
            conector.loading = false
            return
          }
          
          // Verificar status da integração
          const statusResponse = await IntegrationsService.getGithubStatus()
          const status = statusResponse.data
          
          if (status.connected) {
            // Sucesso!
            console.log('✅ GitHub conectado com sucesso:', status)
            conector.conectado = true
            conector.loading = false
            
            // Fechar janela de autorização
            if (!authWindow.closed) {
              authWindow.close()
            }
            
            this.snackbarText = `GitHub conectado com sucesso! Organização: ${status.accountLogin || 'N/A'}`
            this.snackbarColor = 'success'
            this.snackbar = true
            
            return
          }
          
          // Ainda não conectado, tentar novamente
          tentativas++
          if (tentativas < maxTentativas) {
            setTimeout(checkStatus, 1000) // Verificar a cada 1 segundo
          } else {
            // Timeout
            console.log('⏱️ Timeout aguardando conexão GitHub')
            conector.loading = false
            if (!authWindow.closed) {
              authWindow.close()
            }
            this.snackbarText = 'Tempo limite excedido. Tente novamente.'
            this.snackbarColor = 'warning'
            this.snackbar = true
          }
        } catch (error) {
          console.error('Erro ao verificar status:', error)
          // Continuar tentando até timeout
          tentativas++
          if (tentativas < maxTentativas && !authWindow.closed) {
            setTimeout(checkStatus, 1000)
          } else {
            conector.loading = false
            if (!authWindow.closed) {
              authWindow.close()
            }
          }
        }
      }
      
      // Iniciar polling
      setTimeout(checkStatus, 2000) // Aguardar 2s antes da primeira verificação
    },

    async desconectarGithub(conector) {
      conector.loading = true
      try {
        await IntegrationsService.disconnectGithub()
        conector.conectado = false
        this.snackbarText = 'GitHub desconectado com sucesso'
        this.snackbarColor = 'info'
        this.snackbar = true
        console.log('✅ GitHub desconectado')
      } catch (error) {
        console.error('❌ Erro ao desconectar GitHub:', error)
        const msg = error.response?.data?.error || 'Erro ao desconectar GitHub'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        conector.loading = false
      }
    },

    // === Jira OAuth Flow ===
    async conectarJira(conector) {
      const tenantId = this.$store.state.user?.tenantId || localStorage.getItem('tenantId')
      
      if (!tenantId) {
        this.snackbarText = 'Erro: Tenant ID não encontrado'
        this.snackbarColor = 'error'
        this.snackbar = true
        console.error('❌ TenantId não encontrado. Store user:', this.$store.state.user)
        return
      }

      conector.loading = true
      
      try {
        // Abrir popup diretamente no endpoint /connect do backend.
        // O backend DEVE retornar 302 redirect para a URL de autorização da Atlassian.
        // Dessa forma o popup visita o ngrok primeiro (setando o cookie do interstitial)
        // e depois é redirecionado automaticamente para o login da Atlassian.
        const backendUrl = (process.env.VUE_APP_BACKEND_URL || 'http://localhost:8080').replace(/\/$/, '')
        const connectUrl = backendUrl + '/api/integrations/jira/connect?tenantId=' + encodeURIComponent(tenantId)

        this.snackbarText = 'Abrindo autorização Jira...'
        this.snackbarColor = 'info'
        this.snackbar = true

        const popupFeatures = 'width=600,height=700,left=' + ((window.screen.width - 600) / 2) + ',top=' + ((window.screen.height - 700) / 2)
        const authWindow = window.open(connectUrl, 'Jira Authorization', popupFeatures)

        if (!authWindow) {
          throw new Error('Popup bloqueado. Permita popups para este site.')
        }

        console.log('✅ Popup aberto em:', connectUrl)

        this.snackbarText = 'Se aparecer aviso do ngrok, clique em "Visit Site" e aguarde...'
        this.snackbarColor = 'warning'
        this.snackbar = true
        
        // Aguardar conclusão do OAuth
        await this.aguardarConexaoJira(conector, authWindow)
        
      } catch (error) {
        console.error('❌ Erro ao conectar Jira:', error)
        const msg = error.response?.data?.error || error.message || 'Erro ao conectar Jira'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
        conector.loading = false
      }
    },

    async aguardarConexaoJira(conector, authWindow) {
      // Fazer polling até que integração seja concluída ou janela seja fechada
      let tentativas = 0
      const maxTentativas = 60 // 60 tentativas = 1 minuto (1s interval)
      const tenantId = this.$store.state.user?.tenantId || localStorage.getItem('tenantId')
      
      const checkStatus = async () => {
        try {
          // Verificar se janela foi fechada
          if (authWindow.closed) {
            console.log('⚠️ Janela de autorização fechada')
            conector.loading = false
            return
          }
          
          // Verificar status da integração
          const statusResponse = await IntegrationsService.getJiraStatus(tenantId)
          const status = statusResponse.data
          
          if (status.connected) {
            // Sucesso!
            console.log('✅ Jira conectado com sucesso:', status)
            conector.conectado = true
            conector.loading = false
            
            // Fechar janela de autorização
            if (!authWindow.closed) {
              authWindow.close()
            }
            
            this.snackbarText = `Jira conectado com sucesso! Cloud ID: ${status.cloudId || 'N/A'}`
            this.snackbarColor = 'success'
            this.snackbar = true
            
            return
          }
          
          // Ainda não conectado, tentar novamente
          tentativas++
          if (tentativas < maxTentativas) {
            setTimeout(checkStatus, 1000) // Verificar a cada 1 segundo
          } else {
            // Timeout
            console.log('⏱️ Timeout aguardando conexão Jira')
            conector.loading = false
            if (!authWindow.closed) {
              authWindow.close()
            }
            this.snackbarText = 'Tempo limite excedido. Tente novamente.'
            this.snackbarColor = 'warning'
            this.snackbar = true
          }
        } catch (error) {
          console.error('Erro ao verificar status:', error)
          // Continuar tentando até timeout
          tentativas++
          if (tentativas < maxTentativas && !authWindow.closed) {
            setTimeout(checkStatus, 1000)
          } else {
            conector.loading = false
            if (!authWindow.closed) {
              authWindow.close()
            }
          }
        }
      }
      
      // Iniciar polling
      setTimeout(checkStatus, 2000) // Aguardar 2s antes da primeira verificação
    },

    async desconectarJira(conector) {
      const tenantId = this.$store.state.user?.tenantId || localStorage.getItem('tenantId')
      
      if (!tenantId) {
        this.snackbarText = 'Erro: Tenant ID não encontrado'
        this.snackbarColor = 'error'
        this.snackbar = true
        return
      }

      conector.loading = true
      try {
        await IntegrationsService.disconnectJira(tenantId)
        conector.conectado = false
        this.snackbarText = 'Jira desconectado com sucesso'
        this.snackbarColor = 'info'
        this.snackbar = true
        console.log('✅ Jira desconectado')
      } catch (error) {
        console.error('❌ Erro ao desconectar Jira:', error)
        const msg = error.response?.data?.error || 'Erro ao desconectar Jira'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        conector.loading = false
      }
    },

    // === Microsoft / Azure DevOps OAuth Flow ===
    async conectarMicrosoft(conector) {
      conector.loading = true

      try {
        // Abrir popup diretamente no endpoint /connect do backend.
        // O backend DEVE retornar 302 redirect para a URL de autorização da Microsoft.
        // Dessa forma o popup visita o ngrok primeiro (setando o cookie do interstitial)
        // e depois é redirecionado automaticamente para o login Microsoft.
        // No callback, o ngrok já tem o cookie setado e não mostra o interstitial.
        const backendUrl = (process.env.VUE_APP_BACKEND_URL || 'http://localhost:8080').replace(/\/$/, '')
        const tenantId = this.$store.state.user?.tenantId || localStorage.getItem('tenantId')
        const connectUrl = backendUrl + '/api/integrations/microsoft/connect' + (tenantId ? '?tenantId=' + encodeURIComponent(tenantId) : '')

        this.snackbarText = 'Abrindo autorização Microsoft...'
        this.snackbarColor = 'info'
        this.snackbar = true

        const popupFeatures = 'width=600,height=700,left=' + ((window.screen.width - 600) / 2) + ',top=' + ((window.screen.height - 700) / 2)
        const authWindow = window.open(connectUrl, 'Microsoft Authorization', popupFeatures)

        if (!authWindow) {
          throw new Error('Popup bloqueado. Permita popups para este site.')
        }

        console.log('✅ Popup aberto em:', connectUrl)

        this.snackbarText = 'Se aparecer aviso do ngrok, clique em "Visit Site" e aguarde...'
        this.snackbarColor = 'warning'
        this.snackbar = true

        // Aguardar conclusão do OAuth
        await this.aguardarConexaoMicrosoft(conector, authWindow)

      } catch (error) {
        console.error('❌ Erro ao conectar Microsoft:', error)
        const msg = error.response?.data?.error || error.message || 'Erro ao conectar Microsoft'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
        conector.loading = false
      }
    },

    async aguardarConexaoMicrosoft(conector, authWindow) {
      let tentativas = 0
      const maxTentativas = 120 // 120 tentativas = 2 minutos (1s interval)

      const checkStatus = async () => {
        try {
          // Verificar se janela foi fechada
          if (authWindow.closed) {
            console.log('⚠️ Janela de autorização Microsoft fechada')
            conector.loading = false
            return
          }

          // Verificar status da integração
          const statusResponse = await IntegrationsService.getMicrosoftStatus()
          const status = statusResponse.data

          if (status.connected) {
            // Sucesso!
            console.log('✅ Microsoft conectado com sucesso:', status)
            conector.conectado = true
            conector.loading = false

            // Guardar info da conta conectada
            if (status.userEmail || status.displayName) {
              this.$set(conector, 'accountLogin', status.displayName || status.userEmail)
            }

            // Fechar janela de autorização
            if (!authWindow.closed) {
              authWindow.close()
            }

            this.snackbarText = 'Azure DevOps conectado com sucesso!' + (status.displayName ? ' (' + status.displayName + ')' : '')
            this.snackbarColor = 'success'
            this.snackbar = true

            return
          }

          // Ainda não conectado, tentar novamente
          tentativas++
          if (tentativas < maxTentativas) {
            setTimeout(checkStatus, 1000)
          } else {
            // Timeout
            console.log('⏱️ Timeout aguardando conexão Microsoft')
            conector.loading = false
            if (!authWindow.closed) {
              authWindow.close()
            }
            this.snackbarText = 'Tempo limite excedido. Tente novamente.'
            this.snackbarColor = 'warning'
            this.snackbar = true
          }
        } catch (error) {
          console.error('Erro ao verificar status Microsoft:', error)
          tentativas++
          if (tentativas < maxTentativas && !authWindow.closed) {
            setTimeout(checkStatus, 1000)
          } else {
            conector.loading = false
            if (!authWindow.closed) {
              authWindow.close()
            }
          }
        }
      }

      // Iniciar polling (aguardar 2s antes da primeira verificação)
      setTimeout(checkStatus, 2000)
    },

    async desconectarMicrosoft(conector) {
      conector.loading = true
      try {
        await IntegrationsService.disconnectMicrosoft()
        conector.conectado = false
        this.$set(conector, 'accountLogin', null)
        this.snackbarText = 'Azure DevOps desconectado com sucesso'
        this.snackbarColor = 'info'
        this.snackbar = true
        console.log('✅ Microsoft desconectado')
      } catch (error) {
        console.error('❌ Erro ao desconectar Microsoft:', error)
        const msg = error.response?.data?.error || 'Erro ao desconectar Azure DevOps'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        conector.loading = false
      }
    },

    // --- Usuários methods ---
    getAvatarColorByName(name) {
      if (!name) return 'rgba(255,255,255,0.1)'
      const colors = ['#22d3ee', '#8b5cf6', '#84cc16', '#f97316', '#f43f5e', '#facc15']
      return colors[name.charCodeAt(0) % colors.length]
    },

    perfilChipColor(perfil) {
      const map = {
        'Admin':       { bg: '#7f1d1d', text: '#fca5a5', icon: 'mdi-shield-account' },
        'Gestor':      { bg: '#3b0764', text: '#d8b4fe', icon: 'mdi-account-tie' },
        'Colaborador': { bg: '#0c2f3a', text: '#67e8f9', icon: 'mdi-account' }
      }
      return map[perfil] || { bg: '#1f1f1f', text: '#888888', icon: 'mdi-account' }
    },

    async resendWelcomeEmail(usuario) {
      this.resendingWelcomeId = usuario.id
      try {
        const tenantId = this.$store.state.user?.tenantId || localStorage.getItem('tenantId')
        const { TenantsService } = await import('@/services')
        await TenantsService.resendWelcomeEmail(tenantId, usuario.id)
        this.snackbarText = `E-mail de boas-vindas reenviado para ${usuario.email}`
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao reenviar e-mail:', error)
        const msg = error.response?.data?.error || 'Erro ao reenviar e-mail de boas-vindas'
        this.snackbarText = msg
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        this.resendingWelcomeId = null
      }
    },

    editarUsuario(usuario) {
      this.editarForm = {
        id: usuario.id,
        nome: usuario.nome || '',
        email: usuario.email || '',
        perfil: usuario.perfil || 'Colaborador',
        status: usuario.status || 'Ativo',
        departamento: usuario.departamento || '',
        avatarUrl: usuario.avatarUrl || null,
        iniciais: usuario.iniciais || '',
      }
      this.dialogEditarUsuario = true
    },

    fecharDialogEditar() {
      this.dialogEditarUsuario = false
      this.editarForm = { id: null, nome: '', email: '', perfil: 'Colaborador', status: 'Ativo', departamento: '', avatarUrl: null, iniciais: '' }
    },

    perfilParaRole(perfil) {
      const map = { 'Admin': 'PLATFORM_OWNER', 'Gestor': 'MANAGER', 'Colaborador': 'EMPLOYEE' }
      return map[perfil] || 'EMPLOYEE'
    },

    async salvarEdicaoUsuario() {
      this.editarLoading = true
      try {
        const payload = {
          name: this.editarForm.nome,
          email: this.editarForm.email,
          role: this.perfilParaRole(this.editarForm.perfil),
          status: this.editarForm.status === 'Ativo' ? 'ACTIVE' : 'INACTIVE',
          departamento: this.editarForm.departamento,
        }
        await TenantUsersService.update(this.editarForm.id, payload)

        const idx = this.usuariosPlataforma.findIndex(u => u.id === this.editarForm.id)
        if (idx > -1) {
          const updated = { ...this.usuariosPlataforma[idx] }
          updated.nome = this.editarForm.nome
          updated.email = this.editarForm.email
          updated.perfil = this.editarForm.perfil
          updated.status = this.editarForm.status
          updated.departamento = this.editarForm.departamento
          const parts = this.editarForm.nome.trim().split(/\s+/)
          updated.iniciais = parts.length >= 2
            ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
            : this.editarForm.nome.substring(0, 2).toUpperCase()
          this.$set(this.usuariosPlataforma, idx, updated)
        }

        this.snackbarText = `${this.editarForm.nome} atualizado com sucesso!`
        this.snackbarColor = 'success'
        this.snackbar = true
        this.fecharDialogEditar()
      } catch (error) {
        console.error('Erro ao salvar usuário:', error)
        this.snackbarText = error.response?.data?.error || 'Erro ao salvar alterações'
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        this.editarLoading = false
      }
    },

    async toggleStatusUsuario(usuario) {
      try {
        const response = await TenantUsersService.toggleStatus(usuario.id)
        const data = response.data.data || response.data
        usuario.status = data.status || (usuario.status === 'Ativo' ? 'Inativo' : 'Ativo')
        this.snackbarText = `${usuario.nome} ${usuario.status === 'Ativo' ? 'ativado' : 'desativado'}`
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao alterar status do usuário:', error)
        this.snackbarText = error.response?.data?.error || 'Erro ao alterar status do usuário'
        this.snackbarColor = 'error'
        this.snackbar = true
      }
    },

    async removerUsuario(usuario) {
      try {
        await TenantUsersService.remove(usuario.id)
        const idx = this.usuariosPlataforma.findIndex(u => u.id === usuario.id)
        if (idx > -1) {
          this.usuariosPlataforma.splice(idx, 1)
        }
        this.snackbarText = `${usuario.nome} removido`
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao remover usuário:', error)
        this.snackbarText = error.response?.data?.error || 'Erro ao remover usuário'
        this.snackbarColor = 'error'
        this.snackbar = true
      }
    },

    fecharDialogConvite() {
      this.dialogConvidarUsuario = false
      this.conviteForm = { nome: '', email: '', perfil: 'Colaborador' }
    },

    async enviarConvite() {
      this.enviandoConvite = true
      try {
        const response = await TenantUsersService.invite(this.conviteForm)
        const data = response.data.data || response.data
        if (data && data.id) {
          this.usuariosPlataforma.push(data)
        } else {
          // Fallback: add locally if backend doesn't return user
          const iniciais = this.conviteForm.nome.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
          this.usuariosPlataforma.push({
            id: Date.now(),
            nome: this.conviteForm.nome,
            email: this.conviteForm.email,
            iniciais,
            perfil: this.conviteForm.perfil,
            status: 'Ativo',
            mfa: false,
            ultimoAcesso: 'Pendente'
          })
        }
        this.snackbarText = `Convite enviado para ${this.conviteForm.email}`
        this.snackbarColor = 'success'
        this.snackbar = true
        this.fecharDialogConvite()
      } catch (error) {
        console.error('Erro ao enviar convite:', error)
        this.snackbarText = error.response?.data?.error || 'Erro ao enviar convite'
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        this.enviandoConvite = false
      }
    },

    // --- Segurança methods ---
    acaoIconConfig(acao) {
      const map = {
        'Login': { icon: 'mdi-login', color: '#22d3ee' },
        'Logout': { icon: 'mdi-logout', color: '#22d3ee' },
        'Edição': { icon: 'mdi-pencil', color: '#3b82f6' },
        'Configuração': { icon: 'mdi-cog', color: '#888888' },
        'Visualização': { icon: 'mdi-eye', color: '#22c55e' },
        'Exportação': { icon: 'mdi-download', color: '#3b82f6' },
        'Exclusão': { icon: 'mdi-delete', color: '#ef4444' },
        'Criação': { icon: 'mdi-plus-circle', color: '#facc15' }
      }
      return map[acao] || { icon: 'mdi-information', color: '#888888' }
    },

    nivelChipConfig(nivel) {
      const map = {
        'Info': { bg: '#0c2f3a', text: '#67e8f9', icon: 'mdi-information' },
        'Atenção': { bg: '#3a2708', text: '#fbbf24', icon: 'mdi-alert' },
        'Crítico': { bg: '#7f1d1d', text: '#fca5a5', icon: 'mdi-alert-circle' }
      }
      return map[nivel] || { bg: '#0c2f3a', text: '#67e8f9', icon: 'mdi-information' }
    },

    renderLoginActivityChart() {
      const canvas = this.$refs.loginActivityChart
      if (!canvas) return
      const Chart = require('chart.js')
      if (this.loginActivityChartInstance) this.loginActivityChartInstance.destroy()

      this.loginActivityChartInstance = new Chart(canvas.getContext('2d'), {
        type: 'line',
        data: {
          labels: this.loginActivityData.labels,
          datasets: [
            {
              label: 'Logins',
              data: this.loginActivityData.logins,
              borderColor: '#2196F3',
              backgroundColor: 'rgba(33, 150, 243, 0.08)',
              borderWidth: 2,
              pointRadius: 3,
              fill: true,
              tension: 0.3
            },
            {
              label: 'Logouts',
              data: this.loginActivityData.logouts,
              borderColor: '#4CAF50',
              backgroundColor: 'rgba(76, 175, 80, 0.08)',
              borderWidth: 2,
              pointRadius: 3,
              fill: true,
              tension: 0.3
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: {
            yAxes: [{ ticks: { beginAtZero: true }, gridLines: { drawBorder: false, color: 'rgba(0,0,0,0.05)' } }],
            xAxes: [{ gridLines: { display: false } }]
          }
        }
      })
    },

    renderAcoesDoughnutChart() {
      const canvas = this.$refs.acoesDoughnutChart
      if (!canvas) return
      const Chart = require('chart.js')
      if (this.acoesDoughnutChartInstance) this.acoesDoughnutChartInstance.destroy()

      this.acoesDoughnutChartInstance = new Chart(canvas.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: this.distribuicaoAcoes.map(a => a.label),
          datasets: [{
            data: this.distribuicaoAcoes.map(a => a.percent),
            backgroundColor: this.distribuicaoAcoes.map(a => a.cor),
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          cutoutPercentage: 65
        }
      })
    },

    async exportarLogs() {
      try {
        const params = { periodo: this.getPeriodoDias(this.logFiltroPeriodo) }
        const response = await SecurityService.exportLogs(params)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `audit-logs-${new Date().toISOString().split('T')[0]}.csv`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        this.snackbarText = 'Logs exportados com sucesso!'
        this.snackbarColor = 'success'
        this.snackbar = true
      } catch (error) {
        console.error('Erro ao exportar logs:', error)
        this.snackbarText = 'Erro ao exportar logs'
        this.snackbarColor = 'error'
        this.snackbar = true
      }
    },

    // --- Helpers ---
    getPeriodoDias(periodo) {
      const map = {
        'Últimos 7 dias': 7,
        'Últimos 30 dias': 30,
        'Últimos 90 dias': 90,
        'Último ano': 365
      }
      return map[periodo] || 30
    },

    // --- Data Loaders ---
    async carregarConectoresDoBackend() {
      try {
        // Verificar status do GitHub separadamente
        const githubConector = this.conectores.find(c => c.id === 'github')
        if (githubConector) {
          try {
            const githubResponse = await IntegrationsService.getGithubStatus()
            const githubStatus = githubResponse.data
            this.$set(githubConector, 'conectado', githubStatus.connected || false)
            if (githubStatus.connected && githubStatus.accountLogin) {
              this.$set(githubConector, 'accountLogin', githubStatus.accountLogin)
            }
            console.log('✅ Status GitHub carregado:', githubStatus)
          } catch (error) {
            console.log('⚠️ GitHub não conectado')
          }
        }

        // Verificar status do Jira separadamente
        const jiraConector = this.conectores.find(c => c.id === 'jira')
        if (jiraConector) {
          try {
            const tenantId = this.$store.state.user?.tenantId || localStorage.getItem('tenantId')
            if (tenantId) {
              const jiraResponse = await IntegrationsService.getJiraStatus(tenantId)
              const jiraStatus = jiraResponse.data
              this.$set(jiraConector, 'conectado', jiraStatus.connected || false)
              if (jiraStatus.connected && jiraStatus.cloudId) {
                this.$set(jiraConector, 'cloudId', jiraStatus.cloudId)
              }
              console.log('✅ Status Jira carregado:', jiraStatus)
            }
          } catch (error) {
            console.log('⚠️ Jira não conectado')
          }
        }

        // Verificar status do Microsoft / Azure DevOps separadamente
        const azureConector = this.conectores.find(c => c.id === 'azure-devops')
        if (azureConector) {
          try {
            const msResponse = await IntegrationsService.getMicrosoftStatus()
            const msStatus = msResponse.data
            this.$set(azureConector, 'conectado', msStatus.connected || false)
            if (msStatus.connected && (msStatus.displayName || msStatus.userEmail)) {
              this.$set(azureConector, 'accountLogin', msStatus.displayName || msStatus.userEmail)
            }
            console.log('✅ Status Microsoft carregado:', msStatus)
          } catch (error) {
            console.log('⚠️ Microsoft não conectado')
          }
        }

        // Carregar outros conectores (endpoint antigo)
        const response = await IntegrationsService.list()
        const data = response.data.data || response.data
        if (Array.isArray(data)) {
          // Merge backend status into local conectores array
          data.forEach(backend => {
            const local = this.conectores.find(c => c.id === backend.id)
            if (local && local.id !== 'github' && local.id !== 'jira' && local.id !== 'azure-devops') { // GitHub, Jira e Azure já foram carregados
              this.$set(local, 'conectado', backend.conectado || false)
            }
          })
        }
        console.log('✅ Conectores carregados do backend')
      } catch (error) {
        console.error('Erro ao carregar conectores:', error)
      }
    },

    async carregarUsuarios() {
      try {
        const response = await TenantUsersService.list()
        const data = response.data.data || response.data
        this.usuariosPlataforma = Array.isArray(data) ? data : (data.content || [])
        console.log('✅ Usuários da plataforma carregados:', this.usuariosPlataforma.length)
      } catch (error) {
        console.error('Erro ao carregar usuários:', error)
      }
    },

    async carregarSeguranca() {
      try {
        const dias = this.getPeriodoDias(this.logFiltroPeriodo)
        const [logsRes, activityRes, actionsRes] = await Promise.all([
          SecurityService.listLogs({ periodo: dias }),
          SecurityService.getLoginActivity({ periodo: dias }),
          SecurityService.getActionsDistribution({ periodo: dias })
        ])

        // Audit Logs
        const logsData = logsRes.data.data || logsRes.data
        this.auditLogs = Array.isArray(logsData) ? logsData : (logsData.content || [])

        // Login Activity
        const activity = activityRes.data.data || activityRes.data
        if (activity) {
          this.loginActivityData = {
            labels: activity.labels || [],
            logins: activity.logins || [],
            logouts: activity.logouts || []
          }
        }

        // Actions Distribution
        const actions = actionsRes.data.data || actionsRes.data
        if (Array.isArray(actions)) {
          this.distribuicaoAcoes = actions
        }

        console.log('✅ Dados de segurança carregados')
        this.$nextTick(() => {
          this.renderLoginActivityChart()
          this.renderAcoesDoughnutChart()
        })
      } catch (error) {
        console.error('Erro ao carregar dados de segurança:', error)
      }
    }
  }
}
</script>

<style scoped>
/* ── Premium SaaS Design Tokens ── */

/* App Bar */
.ta-admin-appbar {
  background: #111111 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid #1f1f1f !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Back button */
.ta-back-btn {
  color: rgba(255, 255, 255, 0.5) !important;
}
.ta-back-btn:hover .v-icon {
  color: #FFFFFF !important;
}

/* Logo — espelho do da-logo-* no tenant-admin */
.ta-logo-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #FF771C;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ta-logo-e {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 800;
  font-family: 'Inter', sans-serif;
  line-height: 1;
}
.ta-logo-text {
  font-size: 15px;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: -0.01em;
  line-height: 1.1;
}
.ta-logo-sub {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 500;
}

/* Header buttons — espelho do da-header-btn */
.ta-header-btn {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(255, 255, 255, 0.65) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}
.ta-header-btn:hover {
  color: #FFFFFF !important;
}

/* Container */
.ta-container {
  padding: 24px 40px !important;
}

/* Transformamos o Wrapper Main para não ter cor de fundo/borda */
.ta-card-main {
  background: transparent !important;
  border: none !important;
}

/* Rounded cards */
.rounded-lg {
  border-radius: 12px !important;
}

/* Filled fields styling */
.v-text-field--filled >>> .v-input__slot {
  background: #111111 !important;
  border-radius: 8px 8px 0 0 !important;
}

.v-text-field--filled >>> .v-input__slot::before {
  border-color: #1f1f1f !important;
}

.v-text-field--filled >>> .v-label {
  color: rgba(255,255,255,0.6) !important;
  font-size: 13px;
}

.v-text-field--filled >>> input {
  caret-color: #22d3ee !important;
  color: #FFFFFF !important;
}

.v-text-field--filled >>> input::placeholder {
  color: rgba(255,255,255,0.4) !important;
}

/* Card title icon styling */
.v-card-title .v-icon {
  opacity: 0.85;
}

/* Tabs styling */
.v-tabs >>> .v-tab {
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 500;
  letter-spacing: 0 !important;
  color: rgba(255,255,255,0.6) !important;
}

.v-tabs >>> .v-tab--active {
  color: #22d3ee !important;
  font-weight: 600;
}

.v-tabs-items {
  border-radius: 0 0 12px 12px;
  background: transparent !important;
}

/* Inner cards */
.v-tab-item .v-card {
  border: 1px solid #1f1f1f !important;
  border-radius: 12px !important;
  background: #111111 !important;
  transition: box-shadow 0.2s ease, transform 0.15s ease, background-color 0.25s ease, border-color 0.25s ease;
}

.v-tab-item .v-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;
}

/* Table styling */
.v-data-table >>> thead th {
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(255,255,255,0.7) !important;
  background: #111111 !important;
}

.v-data-table >>> tbody td {
  font-size: 13px !important;
  color: rgba(255,255,255,0.8) !important;
}

.v-data-table >>> tbody tr:hover {
  background: rgba(34,211,238,0.05) !important;
}

/* Chip styling */
.v-chip {
  font-weight: 500 !important;
  border-radius: 6px !important;
}

/* Button styling */
.v-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 500 !important;
}

/* Invite dialog */
.ta-invite-dialog {
  border: 1px solid #1f1f1f !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.ta-invite-dialog__header {
  padding: 20px 24px 14px !important;
  border-bottom: 1px solid #1f1f1f;
}

.ta-invite-dialog__subtitle {
  color: rgba(255,255,255,0.45) !important;
  margin-top: 2px;
}

.ta-invite-dialog__close {
  color: rgba(255,255,255,0.45) !important;
  background: transparent !important;
  box-shadow: none !important;
}

.ta-invite-dialog__close::before {
  display: none !important;
}

.ta-invite-dialog__close:hover {
  color: rgba(255,255,255,0.85) !important;
}

.ta-invite-dialog__body {
  padding: 18px 24px 14px !important;
}

.ta-invite-field >>> .v-label {
  color: rgba(255,255,255,0.55) !important;
}

.ta-invite-field >>> .v-input__slot {
  background: #0A0B0D !important;
  border-radius: 10px !important;
}

.ta-invite-field >>> fieldset {
  border-color: #1f1f1f !important;
}

.ta-invite-field >>> .v-input--is-focused fieldset {
  border-color: rgba(34,211,238,0.45) !important;
}

.ta-invite-field >>> input,
.ta-invite-field >>> .v-select__selection {
  color: #FFFFFF !important;
}

.ta-invite-field >>> input::placeholder {
  color: rgba(255,255,255,0.3) !important;
}

.ta-invite-field >>> .v-input__append-inner .v-icon {
  color: rgba(255,255,255,0.35) !important;
}

.ta-invite-dialog__footer {
  padding: 16px 24px 20px !important;
  border-top: 1px solid #1f1f1f;
  gap: 12px;
}

.ta-invite-cancel {
  border-color: #2a2a2a !important;
  color: rgba(255,255,255,0.82) !important;
  text-transform: none !important;
  min-width: 92px;
  border-radius: 10px !important;
}

.ta-invite-submit {
  text-transform: none !important;
  min-width: 148px;
  border-radius: 10px !important;
  font-weight: 600 !important;
  color: #071115 !important;
}
</style>

<style>
/* ================================================================
   ADMIN SETTINGS - DARK THEME GLOBAL OVERRIDES
   Força tema escuro em todos os componentes Vuetify
================================================================ */

/* ================================================================
   INVITE DIALOG — global overrides (dialog teleports to body,
   so scoped CSS does NOT reach it — must live here)
================================================================ */
.ta-invite-dialog.v-card,
.ta-invite-dialog.theme--light.v-card,
.ta-invite-dialog.theme--dark.v-card {
  background-color: #111111 !important;
  background: #111111 !important;
  color: #FFFFFF !important;
  border: 1px solid #1f1f1f !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.ta-invite-dialog .v-card__title {
  background: transparent !important;
  color: #FFFFFF !important;
  padding: 20px 24px 14px !important;
  border-bottom: 1px solid #1f1f1f !important;
}

/* Close button — remove dark box, show only the X icon */
.ta-invite-dialog .v-card__title .v-btn.v-btn--icon {
  background: transparent !important;
  box-shadow: none !important;
}

.ta-invite-dialog .v-card__title .v-btn.v-btn--icon::before {
  display: none !important;
}

.ta-invite-dialog .v-card__title .v-btn.v-btn--icon .v-icon {
  color: rgba(255,255,255,0.5) !important;
}

.ta-invite-dialog .v-card__title .v-btn.v-btn--icon:hover .v-icon {
  color: rgba(255,255,255,0.9) !important;
}

.ta-invite-dialog .v-card__text {
  background: transparent !important;
  color: rgba(255,255,255,0.8) !important;
  padding: 20px 24px 12px !important;
}

.ta-invite-dialog .v-card__actions {
  background: transparent !important;
  padding: 12px 24px 20px !important;
  border-top: 1px solid #1f1f1f !important;
}

/* Fields inside dialog */
.ta-invite-dialog .v-input .v-label {
  color: rgba(255,255,255,0.55) !important;
}

.ta-invite-dialog .v-input .v-input__slot {
  background: #0A0B0D !important;
  border-radius: 10px !important;
}

.ta-invite-dialog .v-input fieldset {
  border-color: #2a2a2a !important;
}

.ta-invite-dialog .v-input.v-input--is-focused fieldset {
  border-color: rgba(34,211,238,0.55) !important;
}

.ta-invite-dialog .v-input input,
.ta-invite-dialog .v-input textarea {
  color: #FFFFFF !important;
}

.ta-invite-dialog .v-input input::placeholder,
.ta-invite-dialog .v-input textarea::placeholder {
  color: rgba(255,255,255,0.3) !important;
}

.ta-invite-dialog .v-select__selection {
  color: #FFFFFF !important;
}

.ta-invite-dialog .v-input__append-inner .v-icon,
.ta-invite-dialog .v-input__prepend-inner .v-icon {
  color: rgba(255,255,255,0.4) !important;
}

/* Dropdown menu that opens from the select */
.v-menu__content .v-list,
.v-menu__content .theme--light.v-list {
  background: #111111 !important;
}
.v-menu__content .v-list-item {
  color: rgba(255,255,255,0.82) !important;
}
.v-menu__content .v-list-item:hover {
  background: rgba(255,255,255,0.06) !important;
}

/* ── Main wrapper background ── */
.ta-card-main,
.ta-card-main.theme--light.v-card,
.ta-card-main.theme--dark.v-card {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

/* ── All v-cards inside ta-card-main (includes nested) ── */
.ta-card-main .v-card,
.ta-card-main .theme--light.v-card,
.ta-card-main .theme--dark.v-card {
  background: #111111 !important;
  border-color: #1f1f1f !important;
}

/* ── v-card text elements ── */
.ta-card-main .v-card .v-card__title,
.ta-card-main .v-card .v-card__subtitle,
.ta-card-main .v-card .v-card__text {
  background: transparent !important;
}
.ta-card-main .v-card .v-card__title {
  color: #FFFFFF !important;
}
.ta-card-main .v-card .v-card__subtitle {
  color: rgba(255,255,255,0.6) !important;
}
.ta-card-main .v-card .v-card__text {
  color: rgba(255,255,255,0.8) !important;
}

/* ── Tabs background ── */
.ta-card-main .v-tabs-items,
.ta-card-main .v-tabs-items .v-window__container {
  background: transparent !important;
}
.ta-card-main .v-tab {
  color: rgba(255,255,255,0.55) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}
.ta-card-main .v-tab--active {
  color: #22d3ee !important;
}

/* ── Dividers ── */
.ta-card-main .v-divider,
.ta-card-main hr {
  border-color: #1f1f1f !important;
}

/* ── Text fields / selects ── */
.ta-card-main .v-input .v-input__slot {
  background: #0a0a0a !important;
}
.ta-card-main .v-text-field--filled .v-input__slot,
.ta-card-main .v-select--filled .v-input__slot {
  background: #0a0a0a !important;
}
.ta-card-main .v-text-field--filled .v-input__slot::before,
.ta-card-main .v-select--filled .v-input__slot::before {
  border-color: #1f1f1f !important;
}
.ta-card-main .v-label {
  color: rgba(255,255,255,0.5) !important;
}
.ta-card-main .v-text-field input,
.ta-card-main .v-select input,
.ta-card-main .v-textarea textarea {
  color: #FFFFFF !important;
  caret-color: #22d3ee !important;
}

/* ── Simple tables ── */
.ta-card-main .v-simple-table,
.ta-card-main .v-data-table {
  background: transparent !important;
}
.ta-card-main .v-simple-table thead tr,
.ta-card-main .v-data-table thead tr {
  background: #0a0a0a !important;
}
.ta-card-main .v-simple-table thead th,
.ta-card-main .v-data-table thead th {
  color: rgba(255,255,255,0.6) !important;
  background: #0a0a0a !important;
  font-size: 11px !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #1f1f1f !important;
}
.ta-card-main .v-simple-table tbody td,
.ta-card-main .v-data-table tbody td {
  color: rgba(255,255,255,0.8) !important;
  background: transparent !important;
  border-bottom: 1px solid #1f1f1f !important;
}
.ta-card-main .v-simple-table tbody tr:hover td,
.ta-card-main .v-data-table tbody tr:hover td {
  background: rgba(34,211,238,0.05) !important;
}

/* ── Override grey--text darken (rendered dark on dark bg) ── */
.ta-card-main .grey--text.text--darken-3,
.ta-card-main .grey--text.text--darken-2 {
  color: rgba(255,255,255,0.7) !important;
}
.ta-card-main .grey--text.text--darken-1,
.ta-card-main .grey--text {
  color: rgba(255,255,255,0.5) !important;
}
.ta-card-main .grey--text.text--lighten-1,
.ta-card-main .grey--text.text--lighten-2 {
  color: rgba(255,255,255,0.4) !important;
}

/* ── Connectors card (inside v-list items) ── */
.ta-card-main .v-list,
.ta-card-main .v-list-item {
  background: transparent !important;
}
.ta-card-main .v-list-item__title {
  color: #FFFFFF !important;
}
.ta-card-main .v-list-item__subtitle {
  color: rgba(255,255,255,0.55) !important;
}

/* ── Chips ── */
.ta-card-main .v-chip.theme--light {
  background: rgba(255,255,255,0.08) !important;
  color: rgba(255,255,255,0.8) !important;
}

/* ── Buttons inside cards ── */
.ta-card-main .v-btn--outlined {
  border-color: #2a2a2a !important;
  color: rgba(255,255,255,0.7) !important;
}

/* ── Switches ── */
.ta-card-main .v-input--switch .v-input__slot {
  background: transparent !important;
}

/* ── Alert inside cards ── */
.ta-card-main .v-alert {
  background: rgba(34,211,238,0.08) !important;
}

/* ── Switch label text ── */
.ta-card-main .v-input--switch .v-label {
  color: rgba(255,255,255,0.8) !important;
}

/* ── Progress bars (horizontal bars for cost/distribution) ── */
.ta-card-main .v-progress-linear {
  background: rgba(255,255,255,0.08) !important;
}

/* ── Stat summary cards inside Financeiro tab ── */
.ta-card-main .v-card.theme--light.v-sheet {
  background: #111111 !important;
  color: #FFFFFF !important;
}

/* ── Connector cards specifically ── */
.ta-card-main .v-col .v-card,
.ta-card-main .v-row .v-card {
  background: #111111 !important;
}

/* ── Sub-tabs (Segurança: Auditoria/Políticas/Relatórios) ── */
.ta-card-main .v-tabs .v-tab {
  color: rgba(255,255,255,0.55) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}
.ta-card-main .v-tabs .v-tab--active {
  color: #22d3ee !important;
}
.ta-card-main .v-tabs .v-tabs-slider-wrapper .v-tabs-slider {
  background-color: #22d3ee !important;
}
.ta-card-main .v-tabs-items .v-tabs-items {
  background: transparent !important;
}

/* ── Dropdown menus (v-menu, v-list) ── */
.v-menu__content .v-list {
  background: #111111 !important;
  border: 1px solid #1f1f1f !important;
}
.v-menu__content .v-list-item {
  color: rgba(255,255,255,0.8) !important;
}
.v-menu__content .v-list-item:hover {
  background: rgba(255,255,255,0.06) !important;
}
.v-menu__content .v-list-item .v-icon {
  color: rgba(255,255,255,0.5) !important;
}

/* ── App bar & layout — sem bordas laterais (padrão tenant-admin) ── */
.ta-admin-appbar.v-app-bar,
.ta-admin-appbar.theme--light.v-app-bar,
.ta-admin-appbar.theme--dark.v-app-bar,
.ta-app .v-app-bar,
.ta-app .v-toolbar {
  background-color: #111111 !important;
  background: #111111 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  outline: none !important;
}

.ta-admin-appbar .v-toolbar__content,
.ta-app .v-toolbar__content {
  background: #111111 !important;
}

.ta-app .v-application--wrap {
  background: #0a0a0a !important;
  min-height: 100vh;
}
</style>